import React, { useState, useEffect } from 'react';
import { MapPin, Building2, Home, Download, Send, Edit, Trash2, Plus, Search, FileText, Globe, Filter, PlusCircle, Eye, X, Upload, Image, CheckCircle } from 'lucide-react';
import apiService from '../config';
// import { HighwayPrathmikAdhisuchna } from "../Highway/HighwayPrathmikAdhisuchna";
import { useLanguage } from '../StoreContext/LanguageContext';
import { useRef } from "react";
import { useSignature } from '../DigitalSignature/UseSignatue';
import SignaturePad from '../DigitalSignature/SignaturePad';

const HighwayPublishProposal = ({ setSubComponent, setSelectedComponent, onBack }) => {
    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [currentProposalId, setCurrentProposalId] = useState(null);
    const [currentProjectName, setCurrentProjectName] = useState(null);
    const [proposalData, setProposalData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { language, translations } = useLanguage();

    const [showPrathmik, setShowPrathmik] = useState(false);

    // Modal states
    const [showViewModal, setShowViewModal] = useState(false); // This controls the INLINE "View Details" expansion
    const [showSendToDSLRModal, setShowSendToDSLRModal] = useState(false);
    const [showPublishModal, setShowPublishModal] = useState(false);
    const [showSendToCoordinationModal, setShowSendToCoordinationModal] = useState(false); // New modal state

    // Send to DSLR states
    const [selectedDocumentDSLR, setSelectedDocumentDSLR] = useState(null);
    const [remarksDSLR, setRemarksDSLR] = useState('Approved');
    const [sendingToDSLR, setSendingToDSLR] = useState(false);
    const [usersDSLR, setUsersDSLR] = useState([]);
    const [loadingUsersDSLR, setLoadingUsersDSLR] = useState(false);
    const [selectedUserDSLR, setSelectedUserDSLR] = useState('');

    // Send to Coordination states
    const [selectedDocumentCoordination, setSelectedDocumentCoordination] = useState(null);
    const [remarksCoordination, setRemarksCoordination] = useState('Approved');
    const [sendingToCoordination, setSendingToCoordination] = useState(false);
    const [usersCoordination, setUsersCoordination] = useState([]);
    const [loadingUsersCoordination, setLoadingUsersCoordination] = useState(false);
    const [selectedUserCoordination, setSelectedUserCoordination] = useState('');

    // Documents Viewer state
    const [showDocumentViewer, setShowDocumentViewer] = useState(false); // Unified document viewer modal
    const [fileUrlToView, setFileUrlToView] = useState('');
    const [isPDFToView, setIsPDFToView] = useState(false);

    const [selectedDocuments, setSelectedDocuments] = useState({}); // For documents selected in publish modal during new upload
    const [buttonDisabled, setButtonDisabled] = useState(false); // For DSLR button disable
    const [sendToRole, setSendToRole] = useState('');

    // Exemption button
    const [isSamanvaySendButtonDisabled, setIsSamanvaySendButtonDisabled] = useState(false);
    const [isCollectorSendButtonDisabled, setIsCollectorSendButtonDisabled] = useState(false);
    const [isBackLAOSendButtonDisabled, setIsBackLAOSendButtonDisabled] = useState(false);

    // Publish Button
    const [publishButton, setPublishButton] = useState(false);
    const [collectorBackToLaoDate, setCollectorBackToLaoDate] = useState(false);

    // digital signature
    const { uploadStatus, uploadError, selectedSignDocument, signDocument, resetSignatureState } = useSignature();
    const [showSignaturePad, setShowSignaturePad] = useState(false);
    const [pdfForSigning, setPdfForSigning] = useState(null);
    const [isTehsildarSendButtonDisabled, setIsTehsildarSendButtonDisabled] = useState(false);
    const [isCollectorButtonDisabled, setIsCollectorButtonDisabled] = useState(false);


    // Publish states
    const [publishData, setPublishData] = useState({
        // propsal_proceeding_no: '',
        // propsal_proceeding_date: '',
        propsal_publication_no: '',
        propsal_publication_date: '',
        // section_11_bhusampadan_no:'',
        // acquisition_proposal_no: '',
        // acquisition_proposal_date: '',
        // administrative_order_no: '',
        // administrative_order_date: '',
        // date_of_extension: '',
        // appointed_administrator: '',
        // published_newspaper: '',
        // published_gazette: '',
        section11_published_gazette_no: '',
        section11_published_gazette: '',
        section11_published_newspaper1_no: '',
        section11_published_newspaper1: '',
        section11_published_newspaper2_no: '',
        section11_published_newspaper2: '',
        section11_municipal_authority_no: '',
        section11_municipal_authority: '',
        section11_collector_office_no: '',
        section11_collector_office: '',
        section11_sub_divisional_office_no: '',
        section11_sub_divisional_office: '',
        section11_tehsil_office_no: '',
        section11_tehsil_office: '',
        section11_government_notice_board_no: '',
        section11_government_notice_board: '',
        section11_gram_sevak_office_no: '',
        section11_gram_sevak_office: '',
        section11_gram_panchayat_office_no: '',
        section11_gram_panchayat_office: '',
        section11_rehabilitation_rights_notice_no: '',
        section11_rehabilitation_rights_notice: ''
    });

    // Image upload states
    const [uploadedImages, setUploadedImages] = useState({
        // proposal_proceding: null,
        // administrative_order: null,
        // proposal_publication: null,
        // acquisition_proposal: null,
        // date_extension: null,
        // appointed_admin: null,
        // newspaper: null,
        // gazette: null,
        // exemptionFile: null // This will hold the File object for upload
        section11_published_gazette_img: '',
        section11_published_newspaper1_img: '',
        section11_published_newspaper2_img: '',
        section11_municipal_authority_img: '',
        section11_collector_office_img: '',
        section11_sub_divisional_office_img: '',
        section11_tehsil_office_img: '',
        section11_government_notice_board_img: '',
        section11_gram_sevak_office_img: '',
        section11_gram_panchayat_office_img: '',
        section11_rehabilitation_rights_notice_img: '',
    });

    // const [showSendToCollectorExtendDateModal, setShowSendToCollectorExtendDateModal] = useState(false);
    const [remarks, setRemarks] = useState('');
    const [selectedDocument, setSelectedDocument] = useState(null);

    const [sendingToCollecotr, setSendingToCollecotr] = useState(false);
    // Send to LAO states
    const [selectedDocumentLAO, setSelectedDocumentLAO] = useState(null);
    const [remarksLAO, setRemarksLAO] = useState('Approved');
    const [sendingToLAO, setSendingToLAO] = useState(false);
    const [usersLAO, setUsersLAO] = useState([]);
    const [loadingUsersLAO, setLoadingUsersLAO] = useState(false);
    const [selectedUserLAO, setSelectedUserLAO] = useState('');
    const [showSendToLAOModal, setShowSendToLAOModal] = useState(false); // New LAO modal state
    const [selectedDocumentCollector, setSelectedDocumentCollector] = useState(null);
    const [remarksCollector, setRemarksCollector] = useState('Approved');
    const [sendingToCollector, setSendingToCollector] = useState(false);
    const [usersCollector, setUsersCollector] = useState([]);
    const [loadingUsersCollector, setLoadingUserCollector] = useState(false);
    const [selectedUserCollector, setSelectedUserCollector] = useState('');

    const tableRef = useRef(null);
    const detailRef = useRef(null);
    const buttonRef = useRef(null);

    const [showSendToTehsildarModal, setShowSendToTehsildarModal] = useState(false);
    const [usersTehsildar, setUsersTehsildar] = useState([]);
    const [selectedUserTehsildar, setSelectedUserTehsildar] = useState('');
    const [remarksTehsildar, setRemarksTehsildar] = useState('');
    const [selectedDocumentTehsildar, setSelectedDocumentTehsildar] = useState(null);
    const [loadingUsersTehsildar, setLoadingUsersTehsildar] = useState(false);
    const [sendingToTehsildar, setSendingToTehsildar] = useState(false);

    // Extended Date / File / Remarks modal
    const [showExtendedModal, setShowExtendedModal] = useState(false);
    const [extendedDate, setExtendedDate] = useState('');
    const [documentFile, setDocumentFile] = useState(null);
    const [documentRemarks, setDocumentRemarks] = useState('Approved');
    const [showSendForExtendedModal, setShowSendForExtendedModal] = useState(false);
    const [sendingToUser, setsendingToUser] = useState(false);
    const [selectedUser, setSelectedUser] = useState('');
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [users, setUsers] = useState([]);
    const [extendsButtonDisabled, setExtendsButtonDisabled] = useState(false);

    // ADD THESE NEW STATE VARIABLES HERE:
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [alertConfig, setAlertConfig] = useState({
        title: '',
        message: '',
        type: 'success'
    });
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmConfig, setConfirmConfig] = useState({
        title: '',
        message: '',
        onConfirm: null,
        onCancel: null,
        type: 'warning'
    });

    // ADD THESE HELPER FUNCTIONS HERE:
    const showAlert = (title, message, type = 'info') => {
        setAlertConfig({ title, message, type });
        setShowAlertModal(true);

        // Don't auto-hide success messages so user can see them
        if (type !== 'success') {
            setTimeout(() => setShowAlertModal(false), 5000);
        }
    };

    const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
        setConfirmConfig({ title, message, onConfirm, onCancel, type });
        setShowConfirmModal(true);
    };

    // Optional: This can be used if needed to close modals consistently
    // const closeModal = () => {
    //     setShowSendToCollectorExtendDateModal(false);
    //     setRemarks('');
    //     setSelectedDocument(null);
    //     setSelectedUser('');
    // };

    const [publishing, setPublishing] = useState(false);
    // const userRole = JSON.parse(localStorage.getItem('userData'))?.data?.usr_role || '';
    const ROLES = {
        COLLECTOR: 1,
        LAO: 3,
        SAMANVAY: 6,
        PROJECT_INCHARGE: 18,
        DATA_ENTRY: 14
    };

    const userData = JSON.parse(localStorage.getItem('userData'));
    const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);

    // Project Id
    useEffect(() => {
        const getProjectInfo = () => {
            const currentProjectData = localStorage.getItem('currentProjectData');
            if (currentProjectData) {
                try {
                    const projectData = JSON.parse(currentProjectData);
                    return {
                        id: projectData.project_id || projectData.id,
                        name: projectData.project_name || projectData.name
                    };
                } catch (e) {
                    console.error('Error parsing current project data (currentProjectData):', e);
                }
            }

            const selectedProject = localStorage.getItem('selectedProject');
            if (selectedProject) {
                try {
                    const project = JSON.parse(selectedProject);
                    return {
                        id: project.project_id || project.id,
                        name: project.project_name || project.name
                    };
                } catch (e) {
                    console.error('Error parsing selected project (selectedProject):', e);
                }
            }

            const userData = localStorage.getItem('userData');
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    const projectId = user.data?.project_id || user.project_id;
                    const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
                    return {
                        id: projectId,
                        name: projectName
                    };
                } catch (e) {
                    console.error('Error parsing user data (userData):', e);
                }
            }
            return { id: null, name: null };
        };

        const projectInfo = getProjectInfo();
        setCurrentProjectId(projectInfo.id);
        setCurrentProjectName(projectInfo.name);
        console.log('Current Project Info:', projectInfo);
    }, []);

    // Proposal id
    useEffect(() => {
        const getProposalInfo = () => {
            const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

            if (currentProposal) {
                try {
                    return {
                        proposalId: currentProposal?.data?.default_proposal ||
                            currentProposal?.data?.proposal_id ||
                            currentProposal?.default_proposal ||
                            currentProposal?.proposal_id ||
                            null
                    }
                } catch (e) {
                    console.error('Error parsing current project data (getProposalInfo):', e);
                }
            }
            return { proposalId: null };
        };

        const proposalInfo = getProposalInfo();
        setCurrentProposalId(proposalInfo.proposalId);
        console.log('Current Project-Proposal Info:', proposalInfo);
    }, []);

    // Fetch Proposal Data
    const fetchProposalData = async () => {
        if (!currentProjectId || !currentProposalId) {
            setLoading(false);
            setError('Project ID or Proposal ID is missing.');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await apiService.getHighwayProposalPublish(currentProjectId, currentProposalId);
            if (response.status === 200 && response.data) {
                setProposalData(response.data);
                console.log('Fetched proposal data:', response.data.section_11_date);
                // Initialize publishData with fetched data if available
                setPublishData(prev => ({
                    ...prev,
                    propsal_proceeding_no: response.data.propsal_proceeding_no || '',
                    propsal_proceeding_date: response.data.propsal_proceeding_date && response.data.propsal_proceeding_date !== "1900-01-01T00:00:00.000Z" ? new Date(response.data.propsal_proceeding_date).toISOString().split('T')[0] : '',
                    propsal_publication_no: response.data.propsal_publication_no || '',
                    propsal_publication_date: response.data.propsal_publication_date && response.data.propsal_publication_date !== "1900-01-01T00:00:00.000Z" ? new Date(response.data.propsal_publication_date).toISOString().split('T')[0] : '',
                    // acquisition_proposal_no: response.data.acquisition_proposal_no || '',
                    // acquisition_proposal_date: response.data.acquisition_proposal_date && response.data.acquisition_proposal_date !== "1900-01-01T00:00:00.000Z" ? new Date(response.data.acquisition_proposal_date).toISOString().split('T')[0] : '',
                    administrative_order_no: response.data.administrative_order_no || '',
                    administrative_order_date: response.data.administrative_order_date && response.data.administrative_order_date !== "1900-01-01T00:00:00.000Z" ? new Date(response.data.administrative_order_date).toISOString().split('T')[0] : '',
                    // date_of_extension: response.data.date_of_extension && response.data.date_of_extension !== "1900-01-01T00:00:00.000Z" ? new Date(response.data.date_of_extension).toISOString().split('T')[0] : '',
                    // appointed_administrator: response.data.appointed_administrator || '', // This seems to be a date in your data, but string in publishData. Confirm type.
                    published_newspaper: response.data.published_newspaper && response.data.published_newspaper !== "1900-01-01T00:00:00.000Z" ? new Date(response.data.published_newspaper).toISOString().split('T')[0] : '',
                    published_gazette: response.data.published_gazette && response.data.published_gazette !== "1900-01-01T00:00:00.000Z" ? new Date(response.data.published_gazette).toISOString().split('T')[0] : '',
                    is_exemption_applicable: response.data.is_exemption_applicable,
                    exemption_type: response.data.exemption_type || '',
                    exemption_notification_number: response.data.exemption_notification_number || '',
                }));
                // Initialize uploadedImages if file URLs are present
                setUploadedImages(prev => ({
                    ...prev,
                    exemptionFile: response.data.exemptionFile || null // This will be the URL, not a File object initially
                }));
            } else {
                setError('No proposal data found');
            }
        } catch (err) {
            console.error('Error fetching proposal data:', err);
            setError('Failed to fetch proposal data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProposalData();
        fetchBackToLAODate();
    }, [currentProjectId, currentProposalId]);

    useEffect(() => {
        const fetchTehsildarUsers = async () => {
            try {
                const response = await apiService.getAllUserTehsildar();
                console.log('Tehsildar users:', response);
                if (response.status === 200 && response.data) {
                    console.log("----------Tehsildar users fetched successfully:", response.data);
                    setUsersTehsildar(Array.isArray(response.data) ? response.data : []);
                } else {
                    setUsersTehsildar([]);
                }
            } catch (error) {
                console.error('Error fetching Collector users:', error);
                setUsersTehsildar([]);
            } finally {

            }
        };

        fetchTehsildarUsers();
    }, []);

    const fetchBackToLAODate = async () => {
        try {
            if (!currentProjectId || !currentProposalId) return;

            const response = await apiService.getHighwayfetchLAOPublishButton(currentProjectId, currentProposalId);

            // Check status and if data exists
            if (response.status === 200 && response.data.length > 0) {
                const startDate = response.data[0].cre_usr_dt; // e.g., "2025-09-13T08:48:47.620Z"

                // Convert to YYYY-MM-DD for <input type="date">
                const formattedDate = new Date(startDate).toISOString().split("T")[0];
                setCollectorBackToLaoDate(formattedDate);
            }
        } catch (error) {
            console.error("Error fetching start date:", error);
        }
    };

    // Handle Publish
    const handlePublish = async () => {
        const missingFields = [];

        // if (!publishData.section11_rehabilitation_rights_notice_no) {
        //     missingFields.push("Rehability Rights Notice Number");
        // }
        // if (!publishData.propsal_proceeding_date) {
        //     missingFields.push("Proceeding Date");
        // }
        // if (!publishData.administrative_order_no) {
        //     missingFields.push("Administrative Order Number");
        // }
        // if (!publishData.administrative_order_date) {
        //     missingFields.push("Administrative Order Date");
        // }
        // if (!publishData.propsal_publication_no) {
        //     missingFields.push("Publication Number");
        // }
        // if (!publishData.propsal_publication_date) {
        //     missingFields.push("Publication Date");
        // }

        if (missingFields.length > 0) {
            showAlert(
                `⚠️ Please fill the following required field(s):\n\n- ${missingFields.join(
                    "\n- "
                )}`
            );
            return;
        }
        if (!currentProposalId) {
            showAlert('Proposal ID not available');
            return;
        }

        setPublishing(true);

        try {
            const formData = new FormData();

            // Use current publishData state for values
            Object.keys(publishData).forEach(key => {
                const value = publishData[key];
                if (value !== '' && value !== null && key !== 'is_exemption_applicable') { // is_exemption_applicable is derived
                    formData.append(key, value);
                }
            });

            // Add images (File objects) only if they are newly selected/uploaded
            Object.keys(uploadedImages).forEach(key => {
                if (uploadedImages[key] && uploadedImages[key] instanceof File) {
                    formData.append(key, uploadedImages[key]);
                }
            });

            // Log what's being sent (for debugging)
            console.log('FormData contents for Publish:');
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }

            const response = await apiService.updateHighwayProposalPublish(currentProposalId, formData);

            if (response.ok || response.status === 200) { // Check for ok or 200 status
                showAlert('Proposal published successfully');
                setShowPublishModal(false);

                // Refresh the proposal data after publishing to update UI
                const updatedResponse = await apiService.getHighwayProposalPublish(currentProjectId, currentProposalId);
                if (updatedResponse.status === 200 && updatedResponse.data) {
                    setProposalData(updatedResponse.data);
                    // Re-initialize publishData with fetched data (important for subsequent publishes/checks)
                    setPublishData(prev => ({
                        ...prev,
                        // propsal_proceeding_no: updatedResponse.data.propsal_proceeding_no || '',
                        // propsal_proceeding_date: updatedResponse.data.propsal_proceeding_date && updatedResponse.data.propsal_proceeding_date !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.propsal_proceeding_date).toISOString().split('T')[0] : '',
                        // propsal_publication_no: updatedResponse.data.propsal_publication_no || '',
                        // propsal_publication_date: updatedResponse.data.propsal_publication_date && updatedResponse.data.propsal_publication_date !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.propsal_publication_date).toISOString().split('T')[0] : '',
                        // acquisition_proposal_no: updatedResponse.data.acquisition_proposal_no || '',
                        // acquisition_proposal_date: updatedResponse.data.acquisition_proposal_date && updatedResponse.data.acquisition_proposal_date !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.acquisition_proposal_date).toISOString().split('T')[0] : '',
                        // administrative_order_no: updatedResponse.data.administrative_order_no || '',
                        // administrative_order_date: updatedResponse.data.administrative_order_date && updatedResponse.data.administrative_order_date !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.administrative_order_date).toISOString().split('T')[0] : '',
                        // date_of_extension: updatedResponse.data.date_of_extension && updatedResponse.data.date_of_extension !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.date_of_extension).toISOString().split('T')[0] : '',
                        // appointed_administrator: updatedResponse.data.appointed_administrator || '',
                        // published_newspaper: updatedResponse.data.published_newspaper && updatedResponse.data.published_newspaper !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.published_newspaper).toISOString().split('T')[0] : '',
                        // published_gazette: updatedResponse.data.published_gazette && updatedResponse.data.published_gazette !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.published_gazette).toISOString().split('T')[0] : '',
                        // is_exemption_applicable: updatedResponse.data.is_exemption_applicable,
                        // exemption_type: updatedResponse.data.exemption_type || '',
                        // exemption_notification_number: updatedResponse.data.exemption_notification_number || '',

                        section11_published_gazette_no: updatedResponse.data.section11_published_gazette_no || '',
                        section11_published_gazette: updatedResponse.data.section11_published_gazette && updatedResponse.data.section11_published_gazette !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.section11_published_gazette).toISOString().split('T')[0] : '',
                        section11_published_newspaper1_no: updatedResponse.data.section11_published_newspaper1_no || '',
                        section11_published_newspaper1: updatedResponse.data.section11_published_newspaper1 && updatedResponse.data.section11_published_newspaper1 !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.section11_published_newspaper1).toISOString().split('T')[0] : '',
                        section11_published_newspaper2_no: updatedResponse.data.section11_published_newspaper2_no || '',
                        section11_published_newspaper2: updatedResponse.data.section11_published_newspaper2 && updatedResponse.data.section11_published_newspaper2 !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.section11_published_newspaper2).toISOString().split('T')[0] : '',
                        section11_municipal_authority_no: updatedResponse.data.section11_municipal_authority_no || '',
                        section11_municipal_authority: updatedResponse.data.section11_municipal_authority && updatedResponse.data.section11_municipal_authority !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.section11_municipal_authority).toISOString().split('T')[0] : '',
                        section11_collector_office_no: updatedResponse.data.section11_collector_office_no || '',
                        section11_collector_office: updatedResponse.data.section11_collector_office && updatedResponse.data.section11_collector_office !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.section11_collector_office).toISOString().split('T')[0] : '',
                        section11_sub_divisional_office_no: updatedResponse.data.section11_sub_divisional_office_no || '',
                        section11_sub_divisional_office: updatedResponse.data.section11_sub_divisional_office && updatedResponse.data.section11_sub_divisional_office !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.section11_sub_divisional_office).toISOString().split('T')[0] : '',
                        section11_tehsil_office_no: updatedResponse.data.section11_tehsil_office_no || '',
                        section11_tehsil_office: updatedResponse.data.section11_tehsil_office && updatedResponse.data.section11_tehsil_office !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.section11_tehsil_office).toISOString().split('T')[0] : '',
                        section11_government_notice_board_no: updatedResponse.data.section11_government_notice_board_no || '',
                        section11_government_notice_board: updatedResponse.data.section11_government_notice_board && updatedResponse.data.section11_government_notice_board !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.section11_government_notice_board).toISOString().split('T')[0] : '',
                        section11_gram_sevak_office_no: updatedResponse.data.section11_gram_sevak_office_no || '',
                        section11_gram_sevak_office: updatedResponse.data.section11_gram_sevak_office && updatedResponse.data.section11_gram_sevak_office !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.section11_gram_sevak_office).toISOString().split('T')[0] : '',
                        section11_gram_panchayat_office_no: updatedResponse.data.section11_gram_panchayat_office_no || '',
                        section11_gram_panchayat_office: updatedResponse.data.section11_gram_panchayat_office && updatedResponse.data.section11_gram_panchayat_office !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.section11_gram_panchayat_office).toISOString().split('T')[0] : '',
                        // section11_rehabilitation_rights_notice_no: updatedResponse.data.section11_rehabilitation_rights_notice_no || '',
                        section11_rehabilitation_rights_notice: updatedResponse.data.section11_rehabilitation_rights_notice && updatedResponse.data.section11_rehabilitation_rights_notice !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.section11_rehabilitation_rights_notice).toISOString().split('T')[0] : '',
                        // propsal_publication_no: updatedResponse.data.section11_rehabilitation_rights_notice_no || '',
                        propsal_publication_date: updatedResponse.data.section11_rehabilitation_rights_notice && updatedResponse.data.section11_rehabilitation_rights_notice !== "1900-01-01T00:00:00.000Z" ? new Date(updatedResponse.data.section11_rehabilitation_rights_notice).toISOString().split('T')[0] : '',
                    }));
                    setUploadedImages(prev => ({ // Reset uploaded files
                        // proposal_proceding: null, administrative_order: null, proposal_publication: null,
                        // acquisition_proposal: null, date_extension: null, appointed_admin: null,
                        // newspaper: null, gazette: null, exemptionFile: null

                        section11_published_gazette_img: null,
                        section11_published_newspaper1_img: null,
                        section11_published_newspaper2_img: null,
                        section11_municipal_authority_img: null,
                        section11_collector_office_img: null,
                        section11_sub_divisional_office_img: null,
                        section11_tehsil_office_img: null,
                        section11_government_notice_board_img: null,
                        section11_gram_sevak_office_img: null,
                        section11_gram_panchayat_office_img: null,
                        section11_rehabilitation_rights_notice_img: null,
                    }));
                    setSelectedDocuments({}); // Clear preview documents
                }
            } else {
                // Read error message from response if available
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to publish proposal');
            }

        } catch (error) {
            console.error('Error publishing proposal:', error);
            showAlert(`Failed to publish proposal: ${error.message}`);
        } finally {
            setPublishing(false);
        }
    };

    useEffect(() => {
        if (showSendForExtendedModal) {
            extendedUsers();
        }
    }, [showSendForExtendedModal]);

    const extendedUsers = async () => {
        setLoadingUsers(true);
        try {
            let response;

            if (userRole === ROLES.COLLECTOR) {
                response = await apiService.getAssignLAO(3, currentProjectId, currentProposalId);
            } else if (userRole === ROLES.SAMANVAY) {
                response = await apiService.getAllUserCollector();
            } else if (userRole === ROLES.LAO) {
                response = await apiService.getAllUserRoleSamanvay();
            }

            console.log('Users:', response);
            if (response.status === 200 && response.data) {
                setUsers(Array.isArray(response.data) ? response.data : []);
            } else {
                setUsers([]);
            }
        } catch (error) {
            console.error('Error fetching Collector users:', error);
            setUsers([]);
        } finally {
            setLoadingUsers(false);
        }
    }

    const handleExtendedSubmit = async () => {
        if (!extendedDate) {
            showAlert("Please select a date and file before submitting");
            return;
        }

        try {
            // Get existing extensions from state or proposalData
            const existingDates = proposalData?.proposal_extended_date?.split('`') || [];
            // const existingRemarks = proposalData?.proposal_extended_remarks?.split('`') || [];

            // Add new entry
            const updatedDates = [...existingDates, extendedDate];

            const formData = new FormData();
            formData.append('proposal_extended_date', updatedDates.join('`'));

            console.log('Extended FormData:', formData);

            const response = await apiService.updateHighwayProposalPublish(currentProposalId, formData);

            if (response.ok || response.status === 200) {
                showAlert("Extended proposal submitted successfully!");
                setShowExtendedModal(false);
                setExtendedDate('');
                fetchProposalData(); // refresh data
            } else {
                throw new Error('Failed to submit extended proposal');
            }
        } catch (error) {
            console.error(error);
            showAlert(`Error: ${error.message}`);
        }
    };

    // Handle Send to Collector
    const handleSendToExtendsUsers = async () => {
        if (!selectedUser || !documentFile) {
            alert('Please select a user and upload a document.');
            return;
        }

        if (!currentProjectId || !currentProposalId) {
            alert('Project ID and Proposal ID are required.');
            return;
        }

        setsendingToUser(true);

        try {
            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', currentProposalId);
            formData.append('remarks', documentRemarks);
            formData.append('usr_id', selectedUser);
            formData.append('document', documentFile);

            let response;

            if (userRole === ROLES.COLLECTOR) {
                response = await apiService.postHighwayTrackingbackToLaoExtentedDate(formData);
            } else if (userRole === ROLES.SAMANVAY) {
                response = await apiService.postHighwayTrackingCollectorExtentedDate(formData);
            } else if (userRole === ROLES.LAO) {
                response = await apiService.postHighwayTrackingSamanvayExtentedDate(formData);
            }
            console.log('Send to Collector response:', response);

            if (response.status === 200) {
                let successMessage = "";

                if (userRole === ROLES.COLLECTOR) {
                    successMessage =
                        translations[language]?.SuccessfullySentToCollectorOfficer ||
                        "Successfully sent to Collector Officer!";
                } else if (userRole === ROLES.SAMANVAY) {
                    successMessage =
                        translations[language]?.SuccessfullySentToSamanvayOfficer ||
                        "Successfully sent to Samanvay Officer!";
                } else if (userRole === ROLES.LAO) {
                    successMessage =
                        translations[language]?.SuccessfullySentToLAOOfficer ||
                        "Successfully sent to LAO Officer!";
                } else {
                    successMessage =
                        translations[language]?.SuccessfullySent ||
                        "Successfully sent!";
                }

                alert(successMessage);
                fetchButtonStatus();
                setShowSendForExtendedModal(false);
                setSelectedUser('');
                setDocumentRemarks('Approved');
                setDocumentFile(null);
            } else {
                alert('Failed to send. Please try again.');
            }
        } catch (error) {
            console.error('Error sending:', error);
            alert('Failed to send. Please try again.');
        } finally {
            setsendingToUser(false);
        }
    };

    // fetch LAO users (New)
    const fetchUsersLAO = async () => {
        const role = 3
        setLoadingUsersLAO(true);
        try {
            const response = await apiService.getAssignLAO(role, currentProjectId, currentProposalId);
            console.log('Assigned LAO response:', response);
            if (response.status === 200 && response.data) {
                setUsersLAO(Array.isArray(response.data) ? response.data : []);
            } else {
                setUsersLAO([]);
            }
        } catch (error) {
            console.error('Error fetching LAO users:', error);
            setUsersLAO([]);
        } finally {
            setLoadingUsersLAO(false);
        }
    };

    useEffect(() => {
        if (showSendToLAOModal) {
            fetchUsersLAO();
        }
    }, [showSendToLAOModal]);

    // Unified function to handle viewing documents (for both modals)
    const handleViewDocument = (urlOrFile) => {
        if (!urlOrFile) return;

        let url;
        let isPdf;

        if (urlOrFile instanceof File) {
            url = URL.createObjectURL(urlOrFile);
            isPdf = urlOrFile.type === 'application/pdf';
        } else { // Assuming it's a URL string from backend
            url = urlOrFile;
            isPdf = urlOrFile.toLowerCase().includes('.pdf');
        }

        setFileUrlToView(url);
        setIsPDFToView(isPdf);
        setShowDocumentViewer(true);
    };

    const closeDocumentViewer = () => {
        setShowDocumentViewer(false);
        // Revoke Object URL if it was created from a File object
        if (fileUrlToView.startsWith('blob:')) {
            URL.revokeObjectURL(fileUrlToView);
        }
        setFileUrlToView('');
        setIsPDFToView(false);
    };

    // Handle image upload
    const handleImageUpload = (imageType, file) => {
        if (!file) return;

        // Store in uploadedImages (will be sent in FormData)
        setUploadedImages(prev => ({
            ...prev,
            [imageType]: file
        }));

        // Also set selectedDocuments for preview within the publish modal
        setSelectedDocuments(prev => ({
            ...prev,
            [imageType]: file
        }));
    };

    // fetch Co-ordination users (New)
    const fetchUsersCoordination = async () => {
        setLoadingUsersCoordination(true);
        try {
            const response = await apiService.getAllUserRoleSamanvay(); // Placeholder API call
            console.log('Coordination users:', response);
            if (response.status === 200 && response.data) {
                setUsersCoordination(Array.isArray(response.data) ? response.data : []);
            } else {
                setUsersCoordination([]);
            }
        } catch (error) {
            console.error('Error fetching Co-ordination users:', error);
            setUsersCoordination([]);
        } finally {
            setLoadingUsersCoordination(false);
        }
    };

    useEffect(() => {
        if (showSendToCoordinationModal) {
            fetchUsersCoordination();
        }
    }, [showSendToCoordinationModal]);

    const fetchUsersDSLR = async () => {
        setLoadingUsersDSLR(true);
        try {
            const response = await apiService.getAllUserRoleSLR();
            console.log('DSLR users:', response);
            if (response.status === 200 && response.data) {
                setUsersDSLR(Array.isArray(response.data) ? response.data : []);
            } else {
                setUsersDSLR([]);
            }
        } catch (error) {
            console.error('Error fetching DSLR users:', error);
            setUsersDSLR([]);
        } finally {
            setLoadingUsersDSLR(false);
        }
    };

    useEffect(() => {
        if (showSendToDSLRModal) {
            fetchUsersDSLR();
        }
    }, [showSendToDSLRModal]);

    // Handle Send to DSLR
    const handleSendToDSLR = async () => {
        if (!selectedUserDSLR || !selectedDocumentDSLR) {
            showAlert('Please select a user and upload a document to send to DSLR Officer.');
            return;
        }

        if (!currentProjectId || !currentProposalId) {
            showAlert('Project ID and Proposal ID are required.');
            return;
        }

        setSendingToDSLR(true);

        try {
            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', currentProposalId);
            formData.append('remarks', remarksDSLR);
            formData.append('usr_id', selectedUserDSLR);
            formData.append('document', selectedDocumentDSLR);

            const response = await apiService.postHighwayTrackingSLR(formData);
            console.log('Send to DSLR response:', response);

            if (response.status === 200) {
                alert(
                    translations[language]?.SuccessfullySentToDSLROfficer
                    //   || "Successfully sent to DSLR Officer!"
                );
                showAlert('Successfully sent to DSLR Officer!');
                await fetchProposalData();
                setShowSendToDSLRModal(false);
                setSelectedUserDSLR('');
                setRemarksDSLR('Approved');
                setSelectedDocumentDSLR(null);
                fetchButtonStatus();
                resetSignatureState();

            } else {
                showAlert('Failed to send to DSLR Officer. Please try again.');
            }
        } catch (error) {
            console.error('Error sending to DSLR:', error);
            showAlert('Failed to send to DSLR Officer. Please try again.');
        } finally {
            setSendingToDSLR(false);
        }
    };
    // Handle Send to Tehsildar
    const handleSendToTehsildar = async () => {
        // if (!selectedUserTehsildar || !selectedDocumentTehsildar) {
        //   alert('Please select a Tehsildar user and upload a document.');
        //   return;
        // }

        if (!currentProjectId || !currentProposalId) {
            alert('Project ID and Proposal ID are required.');
            return;
        }

        setSendingToTehsildar(true);
        console.log("-----------------------1");

        try {
            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', currentProposalId);
            formData.append('remarks', remarksTehsildar);
            formData.append('usr_id', selectedUserTehsildar);
            formData.append('document', selectedDocumentTehsildar);

            // 🔸 Replace with your actual Tehsildar API endpoint
            const response = await apiService.postHighwayTrackingTehsildar(formData);
            console.log('Send to Tehsildar response:', response);

            if (response.status === 200) {
                alert(
                    translations[language]?.SuccessfullySentToTehsildarOfficer ||
                    "Successfully sent to Tehsildar!"
                );

                setIsTehsildarSendButtonDisabled(true);
                setShowSendToTehsildarModal(false);
                setSelectedUserTehsildar('');
                setRemarksTehsildar('Approved');
                setSelectedDocumentTehsildar(null);
                fetchButtonStatus();
                resetSignatureState();
            } else {
                alert('Failed to send to Tehsildar. Please try again.');
            }
        } catch (error) {
            console.error('Error sending to Tehsildar:', error);
            alert('Failed to send to Tehsildar. Please try again.');
        } finally {
            setSendingToTehsildar(false);
        }
    };

    useEffect(() => {
        if (!proposalData) return;
        const isTrue = v => v === 1 || v === '1' || v === true || v === 'true';

        // try a few common field names — adapt to your backend field
        const tehsildarFlag =
            proposalData.tehsildar_exemption_approval ??
            proposalData.tehsildar_sent ??
            proposalData.sent_to_tehsildar ??
            null;

        if (tehsildarFlag !== null) {
            setIsTehsildarSendButtonDisabled(isTrue(tehsildarFlag));
        }
    }, [proposalData]);

    useEffect(() => {
        if (!proposalData) return;

        const isTrue = (value) => {
            return value === 1 || value === "1" || value === true || value === "true";
        };

        // Set button disabled states based on exemption approvals
        setIsSamanvaySendButtonDisabled(isTrue(proposalData.lao_exemption));
        setIsCollectorSendButtonDisabled(isTrue(proposalData.samanvay_exemption_approval));
        setIsBackLAOSendButtonDisabled(isTrue(proposalData.collector_exemption_approval));
    }, [proposalData]);

    // Helper variables
    const isPublished = proposalData &&
        proposalData.propsal_publication_date &&
        proposalData.propsal_publication_date !== '' &&
        proposalData.propsal_publication_date !== "1900-01-01T00:00:00.000Z";

    const isExemptionApplicable = proposalData?.is_exemption_applicable === true ||
        proposalData?.is_exemption_applicable === 'true' ||
        proposalData?.is_exemption_applicable === 1;

    // Corrected button visibility logic based on your requirements
    const shouldShowSamanvayButton = isExemptionApplicable; // Show if exemption applicable (LAO role)
    const shouldShowCollectorButton = isExemptionApplicable && isSamanvaySendButtonDisabled; // Show if samanvay step completed (SAMANVAY role)
    const shouldShowBackToLAOButton = isExemptionApplicable && isCollectorSendButtonDisabled; // Show if collector step completed (COLLECTOR role)

    // Publish button: Show if not published AND (no exemption OR all exemption steps done)
    const allExemptionStepsCompleted = isSamanvaySendButtonDisabled &&
        isCollectorSendButtonDisabled &&
        isBackLAOSendButtonDisabled;

    // const shouldShowPublishButton =
    //     !isPublished && (
    //         (!isExemptionApplicable) || // No exemption: just check not published
    //         (isExemptionApplicable && allExemptionStepsCompleted) // Exemption: all steps must be completed
    //     );

    // const shouldShowPublishButton = !isPublished

    // Data Entry
    // const shouldShowPublishButton = !isPublished && publishButton;
    const shouldShowPublishButton = userRole === ROLES.DATA_ENTRY || (!isPublished && publishButton);

    // DSLR Button Disable (Keep existing logic)
    const fetchButtonStatus = async () => {
        try {
            if (!currentProjectId || !currentProposalId) return;

            // Removed setLoading(true) here as it conflicts with main loading state
            // and is not strictly necessary for just a button state fetch.

            let response = await apiService.getHighwayDSLRButton(currentProjectId, currentProposalId);

            console.log("Button Disable Status (DSLR):", response.buttonDisable);
            setButtonDisabled(!response.buttonDisable); // Assuming true means disable, so invert it

            // Proposal Publish
            let laoResponse = await apiService.getHighwayfetchLAOPublishButton(currentProjectId, currentProposalId);
            setPublishButton(!laoResponse.buttonDisable);

            // Extends date
            let data;
            switch (userRole) {
                case ROLES.LAO:
                    data = await apiService.getHighwaySamanvayExtentedDateButton(currentProjectId, currentProposalId);
                    break;
                case ROLES.SAMANVAY:
                    data = await apiService.getHighwayCollectorExtentedDateButton(currentProjectId, currentProposalId);
                    break;
                case ROLES.COLLECTOR:
                    data = await apiService.getHighwayLaoExtentedDateButton(currentProjectId, currentProposalId);
                    break;
                default:
                    return;
            }
            setExtendsButtonDisabled(!data.buttonDisable);
        } catch (error) {
            console.error("Error fetching DSLR button state:", error);
        } finally {
            // setLoading(false); // Only set loading to false for main data fetch
        }
    };

    useEffect(() => {
        fetchButtonStatus();
    }, [currentProjectId, currentProposalId, isPublished]);

    const fetchCollectorButtonStatus = async () => {
        try {
            if (!currentProjectId || !currentProposalId) return;
            const response = await apiService.getHighwayCollectorButton(currentProjectId, currentProposalId, 'Collector');
            console.log("Collector Button API Response:", response);

            {/* Data Entry */ }
            if (userRole === ROLES.DATA_ENTRY) {
                setIsCollectorButtonDisabled(false);
                return;
            }
            if (response.status === 200) {
                setIsCollectorButtonDisabled(response.buttonDisable === true);
            } else {
                setIsCollectorButtonDisabled(true); // disable by default if API fails
            }
        } catch (error) {
            console.error("Error fetching Collector button status:", error);
            setIsCollectorButtonDisabled(true);
        }
    };

    useEffect(() => {
        fetchProposalData();
        fetchBackToLAODate();
        fetchCollectorButtonStatus(); // <-- Add this line
    }, [currentProjectId, currentProposalId]);

    // Debug logging for publish button
    console.log('Publish Button Debug:', {
        isPublished,
        isExemptionApplicable,
        isSamanvaySendButtonDisabled,
        isCollectorSendButtonDisabled,
        isBackLAOSendButtonDisabled,
        allExemptionStepsCompleted,
        shouldShowPublishButton,
        ROLES_DATA_ENTRY: ROLES.DATA_ENTRY,
        userRole
    });

    // Format date for display
    const formatDate = (dateString) => {
        if (!dateString || dateString === "1900-01-01T00:00:00.000Z") return '-';
        try {
            const date = new Date(dateString);
            // Check if the date is valid before formatting
            if (isNaN(date.getTime())) {
                return 'Invalid Date';
            }
            return date.toLocaleDateString('en-IN');
        } catch (e) {
            console.error("Error formatting date:", dateString, e);
            return 'N/A';
        }
    };

    const formatDateForInput = (dateString) => {
        // If no date provided, use today
        if (!dateString) {
            const today = new Date();
            return today.toISOString().split('T')[0]; // yyyy-mm-dd
        }

        const date = new Date(dateString);

        // Check if date is invalid OR default 1900 date
        if (isNaN(date) || date.getFullYear() === 1900) {
            const today = new Date();
            return today.toISOString().split('T')[0];
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    // Format currency
    const formatCurrency = (amount) => {
        if (!amount) return 'N/A';
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(amount);
    };

    useEffect(() => {
        // Collect dates from row 1–10
        const dates = [
            publishData.section11_published_gazette,
            publishData.section11_published_newspaper1,
            publishData.section11_published_newspaper2,
            publishData.section11_municipal_authority,
            publishData.section11_collector_office,
            publishData.section11_sub_divisional_office,
            publishData.section11_tehsil_office,
            publishData.section11_government_notice_board,
            publishData.section11_gram_sevak_office,
            publishData.section11_gram_panchayat_office,
        ].filter(Boolean); // remove empty/null values

        if (dates.length > 0) {
            // find the latest date
            const latestDate = dates.reduce((a, b) => (a > b ? a : b));

            // update row 11’s date if different
            if (publishData.section11_rehabilitation_rights_notice !== latestDate) {
                setPublishData((prev) => ({
                    ...prev,
                    section11_rehabilitation_rights_notice: latestDate,
                    propsal_publication_date: latestDate
                }));
            }
        }
    }, [
        publishData.section11_published_gazette,
        publishData.section11_published_newspaper1,
        publishData.section11_published_newspaper2,
        publishData.section11_municipal_authority,
        publishData.section11_collector_office,
        publishData.section11_sub_divisional_office,
        publishData.section11_tehsil_office,
        publishData.section11_government_notice_board,
        publishData.section11_gram_sevak_office,
        publishData.section11_gram_panchayat_office,
    ]);

    const maxDateOf10 = [
        publishData.section11_published_gazette,
        publishData.section11_published_newspaper1,
        publishData.section11_published_newspaper2,
        publishData.section11_municipal_authority,
        publishData.section11_collector_office,
        publishData.section11_sub_divisional_office,
        publishData.section11_tehsil_office,
        publishData.section11_government_notice_board,
        publishData.section11_gram_sevak_office,
        publishData.section11_gram_panchayat_office,
    ]
        .filter(Boolean)
        .reduce((a, b) => (a > b ? a : b), '');

    const handlePrint = () => {
        const printContents = tableRef.current.innerHTML;
        const win = window.open("", "_blank");
        win.document.write(`
    <html>
      <head>
        <title>कलम 11(1) खालील प्रारंभिक अधिसूचना प्रसिद्धी तपशील</title>
        <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
        <style>
         .no-print {
              display: none !important;
         }
          @page {
          size: A4 portrait;   /* Orientation */
          margin-top: 0.19in;
          margin-bottom: 0.25in;
          margin-left: 0.81in;
          margin-right: 0.5in;
        }
        body {
          font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
        }
        </style>
      </head>
      <body class="p-6">
        <div class="text-center mb-4 mt-5">
          <h2 class="font-bold text-lg mb-2">कलम 11(1) खालील प्रारंभिक अधिसूचना प्रसिद्धी तपशील</h2>
          <p class="text-sm">Project : ${currentProjectName} | Proposal : ${proposalData.section_11_bhusampadan_no}</p>
        </div>
        <div class="overflow-x-auto">
          ${printContents}
        </div>
        <script>
          window.onload = function() {
            window.print();
          }
        </script>
      </body>
    </html>
  `);
        win.document.close();
    };

    if (loading) {
        return (
            <div className="p-6 max-w-7xl mx-auto">
                <div className="flex justify-center items-center h-80">
                    <div className="text-center animate-float">
                        <div className="inline-flex relative">
                            <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
                            <div className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
                            <div className="absolute inset-0 flex items-center justify-center">
                                <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
                            </div>
                        </div>
                        <p className="text-gray-400 mt-4">{translations[language]?.LoadingProposalData}</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <div className="flex items-center">
                    <div className="text-red-600 mr-3">⚠️</div>
                    <div>
                        <p className="text-red-600">{error}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div ref={buttonRef} className="bg-gray-50 min-h-screen">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                    <div className="flex justify-between items-center">
                        {/* <div>
                            <h1 className="text-2xl font-bold text-gray-900">Publish Proposal</h1>
                            <p className="text-gray-600 mt-1">
                                Project ID: {currentProjectId} | Proposal ID: {currentProposalId || 'Not Found'}
                            </p>
                        </div> */}

                        {/* Buttons */}
                        <div className="flex gap-3">


                            {/* Common button for all roles */}

                            <button
                                disabled={isCollectorButtonDisabled}
                                title={
                                    isCollectorButtonDisabled
                                        ? "Collector Proposal Review is pending for this proposal."
                                        : ""
                                }
                                className={`flex items-center px-6 py-3 rounded-xl shadow-lg transition-all duration-200 
        ${isCollectorButtonDisabled
                                        ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                                        : "bg-sky-700 hover:bg-sky-800 text-white"
                                    }`}
                                onClick={() => {
                                    if (isCollectorButtonDisabled) return; // Prevent click if disabled
                                    console.log('HighwayPrathmikAdhisuchna button clicked');
                                    setSubComponent("HighwayPrathmikAdhisuchna");
                                }}
                            >
                                <FileText className="mr-2 h-5 w-5" />
                                {translations[language]?.PreliminaryNotificationSection11}
                            </button>


                            {userRole === ROLES.LAO && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (isTehsildarSendButtonDisabled) {
                                            showConfirm(
                                                'Confirm Re-submission',
                                                'You have already sent this to Tehsildar. Do you want to send again?',
                                                () => setShowSendToTehsildarModal(true)
                                            );
                                            return;
                                        }
                                        setShowSendToTehsildarModal(true);
                                    }}
                                    className={`px-6 py-2 rounded-lg transition-colors flex items-center space-x-2 ${isTehsildarSendButtonDisabled ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-green-600 text-white hover:bg-green-700'
                                        }`}
                                    title={isTehsildarSendButtonDisabled ? 'Already sent to Tehsildar' : translations[language]?.SendToTehsilar}
                                >
                                    <span>{isTehsildarSendButtonDisabled ? 'Sent to Tehsildar ✓' : translations[language]?.SendToTehsilar}</span>
                                </button>
                            )}

                            {/* {userRole === ROLES.LAO && ( */}
                            {/* Data ENtry */}
                            {(userRole === ROLES.LAO || userRole===ROLES.DATA_ENTRY) && (
                                <>
                                    {/* Send to Co-ordination Office Button - Only show if exemption applicable */}
                                    {shouldShowSamanvayButton && (
                                        <button
                                            // onClick={() => setShowSendToCoordinationModal(true)}
                                            // disabled={isSamanvaySendButtonDisabled}
                                            onClick={() => {
                                                if (isSamanvaySendButtonDisabled) {
                                                    showConfirm(
                                                        'Confirm Re-submission',
                                                        'You have already sent once. Do you want to send again?',
                                                        () => {
                                                            setShowSendToCoordinationModal(true);
                                                        }
                                                    );
                                                    return;
                                                }
                                                setShowSendToCoordinationModal(true);
                                            }}

                                            disabled={false}
                                            className={`flex items-center px-4 py-2 rounded-lg transition-colors ${isSamanvaySendButtonDisabled
                                                ? 'bg-red-600 text-white hover:bg-red-700'  // Red color if already sent
                                                : loading
                                                    ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                                                    : 'bg-purple-600 text-white hover:bg-purple-700'
                                                }`}
                                            title={isSamanvaySendButtonDisabled ? 'Already sent to Samanvay Office' : 'Send to Samanvay Officer'}
                                        >
                                            <Send className="mr-2 h-4 w-4" />
                                            {isSamanvaySendButtonDisabled ? 'Sent to Samanvay Officer ✓' : 'Send to Samanvay Officer'}
                                        </button>
                                    )}

                                    {/* Send to DSLR Button */}
                                    {/* <button
                                        onClick={() => setShowSendToDSLRModal(true)}
                                        disabled={!isPublished || buttonDisabled || loading}
                                        className={`flex items-center px-4 py-2 rounded-lg transition-colors ${!isPublished || buttonDisabled || loading
                                            ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                                            : 'bg-purple-600 text-white hover:bg-purple-700'
                                            }`}
                                        title={!isPublished ? 'Proposal must be published first' : 'Already Send to DSLR Officer'}
                                    >
                                        <Send className="mr-2 h-4 w-4" />
                                        Send to DSLR Officer
                                    </button> */}


                                    {/* Publish Button - Available to all roles when conditions are met */}
                                    {shouldShowPublishButton && (
                                        <button
                                            onClick={() => setShowPublishModal(true)}
                                            disabled={publishing}
                                            className={`flex items-center px-4 py-2 rounded-lg transition-colors ${publishing
                                                ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                                                : 'bg-blue-700 text-white hover:bg-blue-800'
                                                }`}
                                            title="Publish the proposal"
                                        >

                                            <Globe className="mr-2 h-4 w-4" />
                                            {translations[language]?.PublicationPreliminaryNotification}
                                        </button>
                                    )}

                                    {/* Send to DSLR Button */}
                                    {publishButton && (
                                        <button
                                            onClick={() => {
                                                if (buttonDisabled) {
                                                    showConfirm(
                                                        translations[language]?.confirmResubmission,
                                                        translations[language]?.resubmissionWarning,
                                                        () => {
                                                            setShowSendToDSLRModal(true);
                                                        }
                                                    );
                                                    return;
                                                }
                                                setShowSendToDSLRModal(true);
                                            }}
                                            disabled={loading}
                                            className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                                                ? 'bg-red-600 text-white hover:bg-red-700'  // Red color if already sent
                                                : loading
                                                    ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                                                    : 'bg-purple-600 text-white hover:bg-purple-700'
                                                }`}
                                            title={!isPublished
                                                ? 'Proposal must be published first'
                                                : buttonDisabled
                                                    ? translations[language]?.AlreadySentToDSLRClickToResend
                                                    : translations[language]?.PublishProposalSendToDSLROfficer}
                                        >
                                            <Send className="mr-2 h-4 w-4" />
                                            {translations[language]?.PublishProposalSendToDSLROfficer}
                                        </button>
                                    )}

                                </>
                            )}

                            {/* SAMANVAY Role Buttons */}
                            {userRole === ROLES.SAMANVAY && (
                                <>
                                    {/* Send to Collector Button - Show if exemption applicable AND samanvay step completed */}
                                    {/* {shouldShowCollectorButton && (
                                        <button
                                            // onClick={() => setShowSendToCollectorExtendDateModal(true)}
                                            // disabled={isCollectorSendButtonDisabled}
                                            onClick={() => {
                                                if (isCollectorSendButtonDisabled) {
                                                    showConfirm(
                                                        'Confirm Re-submission',
                                                        'You have already sent once. Do you want to send again?',
                                                        () => {
                                                            setShowSendToCollectorExtendDateModal(true);
                                                        }
                                                    );
                                                    return;
                                                }
                                                setShowSendToCollectorExtendDateModal(true);
                                            }}
                                            disabled={false}
                                            className={`flex items-center px-4 py-2 rounded-lg transition-colors ${isCollectorSendButtonDisabled
                                                ? 'bg-red-600 text-white hover:bg-red-700'  // Red color if already sent
                                                : loading
                                                    ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                                                    : 'bg-purple-600 text-white hover:bg-purple-700'
                                                }`}
                                            title={isCollectorSendButtonDisabled ? 'Already sent to Collector' : 'Send to Collector'}
                                        >
                                            <Send className="mr-2 h-4 w-4" />
                                            {isCollectorSendButtonDisabled ? 'Sent to Collector ✓' : 'Send to Collector'}
                                        </button>
                                    )} */}


                                </>
                            )}

                            {/* COLLECTOR Role Buttons */}
                            {userRole === ROLES.COLLECTOR && (
                                <>
                                    {/* Send Back to LAO Button - Show if exemption applicable AND collector step completed */}
                                    {shouldShowBackToLAOButton && (
                                        <button
                                            // onClick={() => setShowSendToLAOModal(true)}
                                            // disabled={isBackLAOSendButtonDisabled}
                                            onClick={() => {
                                                if (isBackLAOSendButtonDisabled) {
                                                    showConfirm(
                                                        'Confirm Re-submission',
                                                        'You have already sent once. Do you want to send again?',
                                                        () => {
                                                            setShowSendToLAOModal(true);
                                                        }
                                                    );
                                                    return;
                                                }
                                                setShowSendToLAOModal(true);
                                            }}
                                            disabled={false}
                                            className={`flex items-center px-4 py-2 rounded-lg transition-colors ${isBackLAOSendButtonDisabled
                                                ? 'bg-red-600 text-white hover:bg-red-700'
                                                : loading
                                                    ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                                                    : 'bg-purple-600 text-white hover:bg-purple-700'
                                                }`}
                                            title={isBackLAOSendButtonDisabled ? 'Already sent back to LAO' : 'Send back to LAO'}
                                        >
                                            <Send className="mr-2 h-4 w-4" />
                                            {isBackLAOSendButtonDisabled ? 'Sent back to LAO ✓' : 'Send Back to LAO'}
                                        </button>
                                    )}

                                </>
                            )}

                            {/* {(userRole === ROLES.LAO || userRole === ROLES.SAMANVAY || userRole === ROLES.COLLECTOR) && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (extendsButtonDisabled) {
                                            showConfirm(
                                                translations[language]?.confirmResubmission,
                                                translations[language]?.resubmissionWarning,
                                                () => setShowSendForExtendedModal(true),
                                                () => console.log("Resend cancelled"),
                                                "danger"
                                            );
                                        } else {
                                            setShowSendForExtendedModal(true);
                                        }
                                    }}
                                    className={`flex items-center px-4 py-2 rounded-lg transition-colors ${extendsButtonDisabled
                                        ? "bg-red-600 text-white hover:bg-red-700"
                                        : "bg-purple-600 text-white hover:bg-purple-700"
                                        }`}
                                    title={
                                        extendsButtonDisabled
                                            ? userRole === ROLES.LAO
                                                ? translations[language]?.AlreadySentToSamanvayOfficerClickToResend
                                                : userRole === ROLES.SAMANVAY
                                                    ? translations[language]?.AlreadySentToCollectorOfficerClickToResend
                                                    : translations[language]?.AlreadySentBackToLAOClickToResend
                                            : userRole === ROLES.LAO
                                                ? translations[language]?.SendToSamanvayOfficerExtendDate
                                                : userRole === ROLES.SAMANVAY
                                                    ? translations[language]?.SendToCollectorExtendDate
                                                    : translations[language]?.SendBackToLAOExtendDate
                                    }
                                >
                                    <Send className="mr-2 h-4 w-4" />
                                    <span>
                                        {userRole === ROLES.LAO
                                            ? translations[language]?.SendToSamanvayOfficerExtendDate
                                            : userRole === ROLES.SAMANVAY
                                                ? translations[language]?.SendToCollectorExtendDate
                                                : translations[language]?.SendBackToLAOExtendDate}
                                    </span>
                                </button>
                            )} */}

                        </div>
                    </div>
                </div>

                {/* Proposal Data Table */}
                {proposalData && (
                    <div className="bg-white rounded-lg shadow-md border border-gray-200 mb-6">
                        {/* Header */}
                        <div className="px-6 py-4 border-b border-gray-200">
                            <div className="flex items-center justify-between">
                                <h2 className="text-lg font-semibold text-gray-800">{translations[language]?.ProposalDetails}</h2>
                                {isPublished ? (
                                    <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-medium">
                                        {translations[language]?.PublicationPreliminaryNotification}
                                    </span>
                                ) : (
                                    <span className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm font-medium">
                                        {translations[language]?.NotPublish}
                                    </span>
                                )}
                            </div>
                        </div>

                        {/* Content Grid */}
                        <div className="p-6">
                            <div className="overflow-x-auto rounded-lg shadow">
                                <table className="min-w-full border border-gray-200 bg-white">
                                    <thead className="bg-gray-100">
                                        <tr>
                                            {proposalData.propsal_publication_date && (
                                                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">{translations[language]?.Action}</th>
                                            )}
                                            <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">{translations[language]?.ProposalNumber}</th>
                                            <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">{translations[language]?.AcquisitionArea}</th>
                                            <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">{translations[language]?.district}</th>
                                            <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">{translations[language]?.taluka}</th>
                                            <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">{translations[language]?.village}</th>
                                            <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">{translations[language]?.Section11Date}</th>
                                            <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">{translations[language]?.Setion11PublicationDate}</th>
                                            <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">{translations[language]?.Section11OneYearDate}</th>
                                            {/* <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">{translations[language]?.ExtensionDate || 'Extension Date'}</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="border-t">
                                            {/* Action */}
                                            {proposalData.propsal_publication_date && (
                                                <td className="px-4 py-2">
                                                    <button
                                                        ref={buttonRef}
                                                        onClick={() => {
                                                            if (!showViewModal) {
                                                                setShowViewModal(true);
                                                                setTimeout(() => {
                                                                    detailRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
                                                                }, 200);
                                                            } else {
                                                                setShowViewModal(false);
                                                                setTimeout(() => {
                                                                    buttonRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
                                                                }, 200);
                                                            }
                                                        }}
                                                        className="flex items-center px-3 py-1 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
                                                    >
                                                        <Eye className="mr-1 h-4 w-4" />
                                                        {showViewModal ? `${translations[language]?.HideDetail}` : `${translations[language]?.ViewDetail}`}
                                                    </button>
                                                </td>
                                            )}
                                            {/* Proposal Number */}
                                            <td className="px-5 py-3 text-gray-900 font-sm">
                                                {proposalData.section_11_bhusampadan_no || proposalData.acquisition_proposal_no || '-'}
                                            </td>

                                            {/* Acquisition Area */}
                                            <td className="px-4 py-2 text-gray-900 font-sm">
                                                {proposalData.aquired_area ? `${proposalData.aquired_area} (${proposalData.area_unit})` : '-'}
                                            </td>

                                            {/* Location */}
                                            <td className="px-4 py-2 text-gray-900 font-sm">
                                                {proposalData.dist_name}
                                            </td>
                                            <td className="px-4 py-2 text-gray-900 font-sm">
                                                {proposalData.taluka_name}
                                            </td>
                                            <td className="px-4 py-2 text-gray-900 font-sm">
                                                {proposalData.village_name}
                                            </td>

                                            {/* Section 11 Back to LAO Date */}
                                            <td className="px-4 py-2 text-gray-900 font-sm">{formatDate(collectorBackToLaoDate)}</td>

                                            {/* Section 11 Publication Date */}
                                            <td className="px-4 py-2 text-gray-900 font-sm">{formatDate(proposalData.section11_rehabilitation_rights_notice)}</td>

                                            {/* Section 11 One Year Date */}
                                            <td className="px-4 py-2 text-red-700 font-sm">
                                                {formatDate(
                                                    proposalData.section11_published_gazette
                                                        ? (() => {
                                                            let date = new Date(proposalData.section11_published_gazette);
                                                            date.setFullYear(date.getFullYear() + 1); // add 1 year
                                                            date.setDate(date.getDate() - 1);         // subtract 1 day
                                                            return date;
                                                        })()
                                                        : null
                                                )}
                                            </td>
                                            {/* <td className="px-4 py-2 text-gray-900 font-sm">
                                                {proposalData?.proposal_extended_date ? (
                                                    proposalData.proposal_extended_date.split('`').map((date, idx) => (
                                                        <div
                                                            key={idx}
                                                            className="text-orange-800 bg-red-100 border border-red-200 rounded-md px-2 py-1 mb-1 text-sm font-medium shadow-sm"
                                                        >
                                                            {`Extended to: ${formatDate(date)}${proposalData.proposal_extended_remarks?.split('`')[idx] ? ` - ${proposalData.proposal_extended_remarks.split('`')[idx]}` : ''}`}
                                                        </div>
                                                    ))
                                                ) : (
                                                    <span className="text-gray-400 text-sm">No extensions</span>
                                                )}
                                            </td> */}

                                            {/* {userRole === ROLES.LAO && (
                                                <td className="px-4 py-2">
                                                    <button
                                                        className="flex items-center px-3 py-1 bg-green-600 hover:bg-green-700 text-white rounded-md"
                                                        onClick={() => setShowExtendedModal(true)}
                                                    >
                                                        <Plus className="w-4 h-4 mr-1" /> Extend
                                                    </button>
                                                </td>
                                            )} */}

                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>

                        {/* Status Footer */}
                        {/* {isPublished ? (
                            <div className="px-6 py-4 bg-green-50 border-t-4 border-green-400">
                                <div className="flex items-center space-x-2">
                                    <span className="text-green-600 text-lg">✅</span>
                                    <p className="text-sm text-green-800">
                                        <span className="font-medium">{translations[language]?.Published}</span>{" "}
                                        {formatDate(proposalData.propsal_publication_date)}{" "}
                                    </p>
                                </div>
                            </div>
                        ) : (
                            <div className="px-6 py-4 bg-orange-50 border-t-4 border-orange-400">
                                <div className="flex items-center space-x-2">
                                    <span className="text-orange-600 text-lg">⚠️</span>
                                    <p className="text-sm text-orange-800">
                                        <span className="font-medium">{translations[language]?.Status}:</span> {translations[language]?.NotPublishedMessage}
                                    </p>
                                </div>
                            </div>
                        )} */}
                    </div>
                )}

                {/* Inline View Details Content (Assuming showViewModal is still used for this section) */}
                {showViewModal && proposalData && (
                    <div ref={detailRef} className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-2xl border border-gray-200">
                        {/* Header */}
                        {/* <div className="bg-gradient-to-r from-blue-600 to-indigo-700 px-4 py-6 rounded-t-2xl">
                            <div className="flex justify-between items-center">
                                <div>
                                    <h3 className="text-2xl font-bold text-white">
                                        Proposal No: {proposalData.acquisition_proposal_no || 'Proposal Information'}
                                    </h3>
                                </div>
                                <button
                                    onClick={() => setShowViewModal(false)}
                                    className="text-white/80 hover:text-white hover:bg-white/20 rounded-full p-2 transition-all duration-200"
                                >
                                    <X className="h-6 w-6" />
                                </button>
                            </div>
                        </div> */}

                        {/* Content */}
                        <div className="">

                            {/* Exemption Details Section in View Modal */}
                            {/* <div className="mt-8">
                                <div className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-xl p-6 border border-orange-200">
                                    <div className="flex items-center mb-4">
                                        <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center mr-3">
                                            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                            </svg>
                                        </div>
                                        <h4 className="text-lg font-semibold text-orange-800">Exemption Details</h4>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="text-xs font-medium text-gray-500 uppercase tracking-wider">Is Exemption Applicable?</label>
                                            <p className="text-gray-900 font-medium">
                                                {proposalData.is_exemption_applicable === true ? 'Yes' : 'No'}
                                            </p>
                                        </div>

                                        {proposalData.is_exemption_applicable === true && (
                                            <>
                                                <div>
                                                    <label className="text-xs font-medium text-gray-500 uppercase tracking-wider">Exemption Type</label>
                                                    <p className="text-gray-900 font-medium">{proposalData.exemption_type || 'N/A'}</p>
                                                </div>
                                                <div>
                                                    <label className="text-xs font-medium text-gray-500 uppercase tracking-wider">Exemption Notification Number</label>
                                                    <p className="text-gray-900 font-medium">{proposalData.exemption_notification_number || 'N/A'}</p>
                                                </div>
                                                <div>
                                                    <label className="text-xs font-medium text-gray-500 uppercase tracking-wider">Exemption File</label>
                                                    <div className="flex items-center"> 
                                                        {proposalData.exemptionFile ? (
                                                            <button
                                                                onClick={() => handleViewDocument(proposalData.exemptionFile)} // Use proposalData.exemptionFile (URL)
                                                                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                                                            >
                                                                View
                                                            </button>
                                                        ) : (
                                                            <span className="text-gray-400 text-sm italic">No file available</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div> */}

                            {/* Publication Details */}

                            <div>
                                <div className="bg-gradient-to-r from-emerald-50 to-green-50 rounded-xl p-6 border border-emerald-200">
                                    <div className="flex items-center justify-between mb-4">
                                        <div className="flex items-center">
                                            <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center mr-3">
                                                <svg
                                                    className="w-4 h-4 text-white"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                                    />
                                                </svg>
                                            </div>
                                            <h4 className="text-lg font-semibold text-emerald-800">
                                                {translations[language]?.ProposalDetails}
                                            </h4>
                                        </div>

                                        <button
                                            onClick={handlePrint}
                                            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
                                        >
                                            {translations[language]?.Print}
                                        </button>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        {/* <div className="flex flex-col space-y-1">
                                            <label className="text-xs font-medium text-emerald-600 uppercase tracking-wider">{translations[language]?.PublicationNo}</label>
                                            <p className="text-emerald-900 font-medium text-lg">{proposalData.propsal_publication_no}</p>
                                        </div> */}
                                        <div className="flex flex-col space-y-1">
                                            <label className="text-xs font-medium text-emerald-600 uppercase tracking-wider">{translations[language]?.PublicationDate}</label>
                                            <p className="text-emerald-900 font-medium text-lg">{formatDate(proposalData.propsal_publication_date)}</p>
                                        </div>
                                    </div>


                                    {/* Proposal Publication Detail */}
                                    <div className="bg-white rounded-xl pt-6 p-6 shadow-sm border border-gray-100 mt-6">

                                        <div className="overflow-x-auto" ref={tableRef}>
                                            <table className="min-w-full table-auto border border-gray-300 shadow rounded-lg text-sm">
                                                <thead className="bg-gray-100">
                                                    <tr>
                                                        <th className="p-3 border text-left font-medium text-gray-700 text-center">{translations[language]?.SrNo}</th>
                                                        <th className="p-3 border text-left font-medium text-gray-700 text-center">{translations[language]?.OfficeofPublication}</th>
                                                        <th className="p-3 border text-left font-medium text-gray-700 text-center">{translations[language]?.PublicationDetails}</th>
                                                        <th className="p-3 border text-left font-medium text-gray-800 text-center">{translations[language]?.DateofPublication}</th>
                                                        <th className="no-print p-3 border text-left font-medium text-gray-800 text-center">{translations[language]?.Documents}</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-200">
                                                    {/* Government Gazette */}
                                                    <tr>
                                                        <td className="p-2 border text-center">1</td>
                                                        <td className="p-2 border">{translations[language]?.GovernmentGazette}</td>
                                                        <td className="p-2 border"><label>{proposalData.section11_published_gazette_no || "-"}</label></td>
                                                        <td className="p-2 border"><label>{formatDate(proposalData.section11_published_gazette)}</label></td>
                                                        <td className="no-print p-2 border text-center">
                                                            {proposalData.section11_published_gazette_img ? (
                                                                <button
                                                                    onClick={() => handleViewDocument(proposalData.section11_published_gazette_img)}
                                                                    className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 mx-auto"
                                                                >
                                                                    <Eye className="h-3 w-3" /> {translations[language].View}
                                                                </button>
                                                            ) : (
                                                                <span className="text-gray-400 text-xs italic">No file available</span>
                                                            )}
                                                        </td>
                                                    </tr>

                                                    {/* Newspaper 1 */}
                                                    <tr>
                                                        <td className="p-2 border text-center">2</td>
                                                        <td className="p-2 border">{translations[language]?.Newspaper1}</td>
                                                        <td className="p-2 border"><label>{proposalData.section11_published_newspaper1_no || "-"}</label></td>
                                                        <td className="p-2 border"><label>{formatDate(proposalData.section11_published_newspaper1)}</label></td>
                                                        <td className="no-print p-2 border text-center">
                                                            {proposalData.section11_published_newspaper1_img ? (
                                                                <button
                                                                    onClick={() => handleViewDocument(proposalData.section11_published_newspaper1_img)}
                                                                    className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 mx-auto"
                                                                >
                                                                    <Eye className="h-3 w-3" /> {translations[language].View}
                                                                </button>
                                                            ) : (
                                                                <span className="text-gray-400 text-xs italic">No file available</span>
                                                            )}
                                                        </td>
                                                    </tr>

                                                    {/* Newspaper 2 */}
                                                    <tr>
                                                        <td className="p-2 border text-center">3</td>
                                                        <td className="p-2 border">{translations[language]?.Newspaper2}</td>
                                                        <td className="p-2 border"><label>{proposalData.section11_published_newspaper2_no || "-"}</label></td>
                                                        <td className="p-2 border"><label>{formatDate(proposalData.section11_published_newspaper2)}</label></td>
                                                        <td className="no-print p-2 border text-center">
                                                            {proposalData.section11_published_newspaper2_img ? (
                                                                <button
                                                                    onClick={() => handleViewDocument(proposalData.section11_published_newspaper2_img)}
                                                                    className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 mx-auto"
                                                                >
                                                                    <Eye className="h-3 w-3" /> {translations[language].View}
                                                                </button>
                                                            ) : (
                                                                <span className="text-gray-400 text-xs italic">No file available</span>
                                                            )}
                                                        </td>
                                                    </tr>

                                                    {/* Municipal Corporation */}
                                                    <tr>
                                                        <td className="p-2 border text-center">4</td>
                                                        <td className="p-2 border">{translations[language]?.MunicipalCorporation}</td>
                                                        <td className="p-2 border"><label>{proposalData.section11_municipal_authority_no || "-"}</label></td>
                                                        <td className="p-2 border"><label>{formatDate(proposalData.section11_municipal_authority)}</label></td>
                                                        <td className="no-print p-2 border text-center">
                                                            {proposalData.section11_municipal_authority_img ? (
                                                                <button
                                                                    onClick={() => handleViewDocument(proposalData.section11_municipal_authority_img)}
                                                                    className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 mx-auto"
                                                                >
                                                                    <Eye className="h-3 w-3" /> {translations[language].View}
                                                                </button>
                                                            ) : (
                                                                <span className="text-gray-400 text-xs italic">No file available</span>
                                                            )}
                                                        </td>
                                                    </tr>

                                                    {/* District Collector Office */}
                                                    <tr>
                                                        <td className="p-2 border text-center">5</td>
                                                        <td className="p-2 border">{translations[language].DistrictCollectorOffice}</td>
                                                        <td className="p-2 border"><label>{proposalData.section11_collector_office_no || "-"}</label></td>
                                                        <td className="p-2 border"><label>{formatDate(proposalData.section11_collector_office)}</label></td>
                                                        <td className="no-print p-2 border text-center">
                                                            {proposalData.section11_collector_office_img ? (
                                                                <button
                                                                    onClick={() => handleViewDocument(proposalData.section11_collector_office_img)}
                                                                    className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 mx-auto"
                                                                >
                                                                    <Eye className="h-3 w-3" /> {translations[language].View}
                                                                </button>
                                                            ) : (
                                                                <span className="text-gray-400 text-xs italic">No file available</span>
                                                            )}
                                                        </td>
                                                    </tr>

                                                    {/* Sub-Divisional Officer */}
                                                    <tr>
                                                        <td className="p-2 border text-center">6</td>
                                                        <td className="p-2 border">{translations[language].SubDivisionalOfficer}</td>
                                                        <td className="p-2 border"><label>{proposalData.section11_sub_divisional_office_no || "-"}</label></td>
                                                        <td className="p-2 border"><label>{formatDate(proposalData.section11_sub_divisional_office)}</label></td>
                                                        <td className="no-print p-2 border text-center">
                                                            {proposalData.section11_sub_divisional_office_img ? (
                                                                <button
                                                                    onClick={() => handleViewDocument(proposalData.section11_sub_divisional_office_img)}
                                                                    className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 mx-auto"
                                                                >
                                                                    <Eye className="h-3 w-3" /> {translations[language].View}
                                                                </button>
                                                            ) : (
                                                                <span className="text-gray-400 text-xs italic">No file available</span>
                                                            )}
                                                        </td>
                                                    </tr>

                                                    {/* Tehsil Office */}
                                                    <tr>
                                                        <td className="p-2 border text-center">7</td>
                                                        <td className="p-2 border">{translations[language].TehsilOffice}</td>
                                                        <td className="p-2 border"><label>{proposalData.section11_tehsil_office_no || "-"}</label></td>
                                                        <td className="p-2 border"><label>{formatDate(proposalData.section11_tehsil_office)}</label></td>
                                                        <td className="no-print p-2 border text-center">
                                                            {proposalData.section11_tehsil_office_img ? (
                                                                <button
                                                                    onClick={() => handleViewDocument(proposalData.section11_tehsil_office_img)}
                                                                    className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 mx-auto"
                                                                >
                                                                    <Eye className="h-3 w-3" /> {translations[language].View}
                                                                </button>
                                                            ) : (
                                                                <span className="text-gray-400 text-xs italic">No file available</span>
                                                            )}
                                                        </td>
                                                    </tr>

                                                    {/* Government Notice Board */}
                                                    <tr>
                                                        <td className="p-2 border text-center">8</td>
                                                        <td className="p-2 border">{translations[language].GovernmentNoticeBoard}</td>
                                                        <td className="p-2 border"><label>{proposalData.section11_government_notice_board_no || "-"}</label></td>
                                                        <td className="p-2 border"><label>{formatDate(proposalData.section11_government_notice_board)}</label></td>
                                                        <td className="no-print p-2 border text-center">
                                                            {proposalData.section11_government_notice_board_img ? (
                                                                <button
                                                                    onClick={() => handleViewDocument(proposalData.section11_government_notice_board_img)}
                                                                    className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 mx-auto"
                                                                >
                                                                    <Eye className="h-3 w-3" /> {translations[language].View}
                                                                </button>
                                                            ) : (
                                                                <span className="text-gray-400 text-xs italic">No file available</span>
                                                            )}
                                                        </td>
                                                    </tr>

                                                    {/* Gram Sevak Office */}
                                                    <tr>
                                                        <td className="p-2 border text-center">9</td>
                                                        <td className="p-2 border">{translations[language].GramSevakOffice}</td>
                                                        <td className="p-2 border"><label>{proposalData.section11_gram_sevak_office_no || "-"}</label></td>
                                                        <td className="p-2 border"><label>{formatDate(proposalData.section11_gram_sevak_office)}</label></td>
                                                        <td className="no-print p-2 border text-center">
                                                            {proposalData.section11_gram_sevak_office_img ? (
                                                                <button
                                                                    onClick={() => handleViewDocument(proposalData.section11_gram_sevak_office_img)}
                                                                    className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 mx-auto"
                                                                >
                                                                    <Eye className="h-3 w-3" /> {translations[language].View}
                                                                </button>
                                                            ) : (
                                                                <span className="text-gray-400 text-xs italic">No file available</span>
                                                            )}
                                                        </td>
                                                    </tr>

                                                    {/* Gram Panchayat Office */}
                                                    {/* <tr>
                                                        <td className="p-2 border text-center">10</td>
                                                        <td className="p-2 border">{translations[language].GramPanchayatOffice}</td>
                                                        <td className="p-2 border"><label>{proposalData.section11_gram_panchayat_office_no || "-"}</label></td>
                                                        <td className="p-2 border"><label>{formatDate(proposalData.section11_gram_panchayat_office)}</label></td>
                                                        <td className="no-print p-2 border text-center">
                                                            {proposalData.section11_gram_panchayat_office_img ? (
                                                                <button
                                                                    onClick={() => handleViewDocument(proposalData.section11_gram_panchayat_office_img)}
                                                                    className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 mx-auto"
                                                                >
                                                                    <Eye className="h-3 w-3" /> {translations[language].View}
                                                                </button>
                                                            ) : (
                                                                <span className="text-gray-400 text-xs italic">No file available</span>
                                                            )}
                                                        </td>
                                                    </tr> */}

                                                    {/* Preliminary Notification under Rule 10 */}
                                                    <tr>
                                                        <td className="p-2 border text-center">10</td>
                                                        <td className="p-2 border">{translations[language].PreliminaryNotificationunderRule10}</td>
                                                        <td className="p-2 border"><label>{proposalData.section11_rehabilitation_rights_notice_no || "-"}</label></td>
                                                        <td className="p-2 border"><label>{formatDate(proposalData.section11_rehabilitation_rights_notice)}</label></td>
                                                        <td className="no-print p-2 border text-center">
                                                            {proposalData.section11_rehabilitation_rights_notice_img ? (
                                                                <button
                                                                    onClick={() => handleViewDocument(proposalData.section11_rehabilitation_rights_notice_img)}
                                                                    className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 mx-auto"
                                                                >
                                                                    <Eye className="h-3 w-3" /> {translations[language].View}
                                                                </button>
                                                            ) : (
                                                                <span className="text-gray-400 text-xs italic">No file available</span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                )}

                {/* Send to DSLR Modal */}
                {showSendToDSLRModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                            <div className="p-6">
                                {/* <div className="flex justify-between items-center mb-6">
                                    <h3 className="text-xl font-semibold text-gray-800">
                                        {translations[language]?.SendToDSLR}
                                    </h3>
                                    <button
                                        onClick={() => setShowSendToDSLRModal(false)}
                                        className="text-gray-400 hover:text-gray-600"
                                    >
                                        <X className="h-6 w-6" />
                                    </button>
                                </div> */}

                                <div className="space-y-4">
                                    {/* User Selection */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            {translations[language]?.SelectUserDSLR} *
                                        </label>
                                        <select
                                            value={selectedUserDSLR}
                                            onChange={(e) => setSelectedUserDSLR(e.target.value)}
                                            disabled={loadingUsersDSLR}
                                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        >
                                            <option value="">
                                                {loadingUsersDSLR ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                                            </option>
                                            {usersDSLR.map((user) => (
                                                <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                    {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Remarks */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            {translations[language]?.Remarks}
                                        </label>
                                        <textarea
                                            value={remarksDSLR}
                                            onChange={(e) => setRemarksDSLR(e.target.value)}
                                            rows={3}
                                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            placeholder="Enter remarks..."
                                        />
                                    </div>

                                    {/* Document Upload */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Upload Document *
                                        </label>
                                        <input
                                            type="file"
                                            onChange={(e) => setSelectedDocumentDSLR(e.target.files[0])}
                                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                        />
                                        {selectedDocumentDSLR && (
                                            <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                                                <div className="flex items-center justify-between mb-2">
                                                    <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                                                        Selected: {selectedDocumentDSLR.name}
                                                    </p>
                                                    <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                                                        {(selectedDocumentDSLR.size / 1024 / 1024).toFixed(2)} MB
                                                    </span>
                                                </div>

                                                {/* Action buttons for the selected document */}
                                                <div className="flex gap-2">
                                                    {/* FIX: Use a React Fragment to wrap the two conditional buttons */}
                                                    {selectedDocumentDSLR.type === 'application/pdf' && (
                                                        <>
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    if (selectedDocumentDSLR?.type === 'application/pdf') {
                                                                        setPdfForSigning(selectedDocumentDSLR);
                                                                        setShowSignaturePad(true);
                                                                    }
                                                                }}
                                                                disabled={uploadStatus === 'uploading'}
                                                                className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                                                            >
                                                                {uploadStatus === 'uploading' ? (
                                                                    <>
                                                                        <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                                                        Signing...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                        </svg>
                                                                        Sign Doc
                                                                    </>
                                                                )}
                                                            </button>

                                                            {/* View button - This was causing the error because it was a sibling of the 'Sign Doc' button inside the same conditional */}
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(
                                                                    uploadStatus === 'success' ? selectedSignDocument : selectedDocumentDSLR
                                                                )}
                                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
                                                            >
                                                                <Eye className="h-3 w-3" />
                                                                View
                                                            </button>
                                                        </>
                                                    )}
                                                </div>

                                                {/* Upload status messages */}
                                                {uploadStatus === 'success' && (
                                                    <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                                                        ✅ Document signed successfully!
                                                    </div>
                                                )}

                                                {uploadStatus === 'error' && uploadError && (
                                                    <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                                                        ❌ {uploadError}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Modal Actions */}
                                <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                    <button
                                        onClick={() => {
                                            setShowSendToDSLRModal(false);
                                            resetSignatureState();
                                            setSelectedDocumentDSLR(null);
                                        }} className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                        disabled={sendingToDSLR}
                                    >
                                        {translations[language]?.Cancel}
                                    </button>
                                    <button
                                        onClick={handleSendToDSLR}
                                        disabled={sendingToDSLR || !selectedUserDSLR || !selectedDocumentDSLR}
                                        className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                    >
                                        {sendingToDSLR ? (
                                            <>
                                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                                {translations[language]?.Send}
                                            </>
                                        ) : (
                                            <>
                                                <Send className="mr-2 h-4 w-4" />
                                                {translations[language]?.CommonSave}
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* SignaturePad Modal */}
                        {showSignaturePad && pdfForSigning && (
                            <SignaturePad
                                pdfFile={pdfForSigning}
                                onSign={(signaturesArray) => {
                                    setShowSignaturePad(false);
                                    signDocument(pdfForSigning, signaturesArray).then(() => {
                                        setPdfForSigning(null);
                                    });
                                }}
                                onCancel={() => {
                                    setShowSignaturePad(false);
                                    setPdfForSigning(null);
                                }}
                            />
                        )}
                    </div>
                )}

                {/* Publish Modal */}
                {showPublishModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl mx-4 max-h-[90vh] overflow-y-auto">

                            <div className="p-6">
                                <div className="flex justify-between items-center mb-6 text-center">
                                    <h3 className="text-xl font-semibold text-gray-800 text-center">
                                        {translations[language]?.PublicationPreliminaryNotification}
                                        {/* <p className="text-xs italic text-gray-500 mt-4">
                                            through section 11
                                        </p>  */}

                                    </h3>

                                    <button
                                        onClick={() => setShowPublishModal(false)}
                                        className="text-gray-400 hover:text-gray-600"
                                    >
                                        <X className="h-6 w-6" />
                                    </button>
                                </div>

                                <div className="overflow-x-auto">
                                    <table className="min-w-full table-auto border border-gray-300 shadow rounded-lg text-sm">
                                        <thead className="bg-gray-100">
                                            <tr>
                                                <th className="p-3 border text-left font-medium text-gray-700 text-center">{translations[language]?.SrNo}</th>
                                                <th className="p-3 border text-left font-medium text-gray-700 text-center">{translations[language]?.OfficeofPublication}</th>
                                                <th className="p-3 border text-left font-medium text-gray-700 text-center">{translations[language]?.No}</th>
                                                <th className="p-3 border text-left font-medium text-gray-800 text-center">{translations[language]?.DateofPublication}</th>
                                                <th className="p-3 border text-left font-medium text-gray-800 text-center">{translations[language]?.Documents}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {/* Government Gazette No and Date */}
                                            <tr>
                                                <td className="p-2 border">1</td>
                                                <td className="p-2 border">{translations[language]?.GovernmentGazette}</td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="text"
                                                        value={publishData.section11_published_gazette_no}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_published_gazette_no: e.target.value })}
                                                        placeholder="Enter Government Gazette No"
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="date"
                                                        value={publishData.section11_published_gazette}
                                                        min={formatDateForInput(proposalData.section_11_date) || ''}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_published_gazette: e.target.value })}
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleImageUpload('section11_published_gazette_img', e.target.files[0])}
                                                        className="w-full p-2 border rounded text-xs green"
                                                    />
                                                    {selectedDocuments['section11_published_gazette_img'] && (
                                                        <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                                            <p className="text-xs text-green-600 truncate max-w-[70%]">
                                                                {translations[language]?.Selected}: {selectedDocuments['section11_published_gazette_img'].name}
                                                            </p>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(selectedDocuments['section11_published_gazette_img'])}
                                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                                            >
                                                                <Eye className="h-3 w-3" /> {translations[language].View}
                                                            </button>
                                                        </div>
                                                    )}

                                                </td>
                                            </tr>

                                            {/* Newspaper - 1 No and Date */}
                                            <tr>
                                                <td className="p-2 border">2</td>
                                                <td className="p-2 border">{translations[language]?.Newspaper1}</td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="text"
                                                        value={publishData.section11_published_newspaper1_no}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_published_newspaper1_no: e.target.value })}
                                                        placeholder="Enter Newspaper - 1 number"
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="date"
                                                        value={publishData.section11_published_newspaper1}
                                                        min={formatDateForInput(proposalData.section_11_date) || ''}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_published_newspaper1: e.target.value })}
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleImageUpload('section11_published_newspaper1_img', e.target.files[0])}
                                                        className="w-full p-2 border rounded text-xs"
                                                    />
                                                    {selectedDocuments['section11_published_newspaper1_img'] && (
                                                        <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                                            <p className="text-xs text-green-600 truncate max-w-[70%]">
                                                                {translations[language]?.Selected}: {selectedDocuments['section11_published_newspaper1_img'].name}
                                                            </p>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(selectedDocuments['section11_published_newspaper1_img'])}
                                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                                            >
                                                                <Eye className="h-3 w-3" /> {translations[language].View}
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>

                                            {/* Newspaper - 2 No and Date */}
                                            <tr>
                                                <td className="p-2 border">3</td>
                                                <td className="p-2 border">{translations[language]?.Newspaper2}</td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="text"
                                                        value={publishData.section11_published_newspaper2_no}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_published_newspaper2_no: e.target.value })}
                                                        placeholder="Enter Newspaper - 2 number"
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="date"
                                                        value={publishData.section11_published_newspaper2}
                                                        min={formatDateForInput(proposalData.section_11_date) || ''}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_published_newspaper2: e.target.value })}
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleImageUpload('section11_published_newspaper2_img', e.target.files[0])}
                                                        className="w-full p-2 border rounded text-xs"
                                                    />
                                                    {selectedDocuments['section11_published_newspaper2_img'] && (
                                                        <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                                            <p className="text-xs text-green-600 truncate max-w-[70%]">
                                                                {translations[language]?.Selected}: {selectedDocuments['section11_published_newspaper2_img'].name}
                                                            </p>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(selectedDocuments['section11_published_newspaper2_img'])}
                                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                                            >
                                                                <Eye className="h-3 w-3" /> {translations[language].View}
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>

                                            {/* Municipal Corporation No and Date */}
                                            <tr>
                                                <td className="p-2 border">4</td>
                                                <td className="p-2 border">{translations[language]?.MunicipalCorporation}</td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="text"
                                                        value={publishData.section11_municipal_authority_no}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_municipal_authority_no: e.target.value })}
                                                        placeholder="Enter Municipal Corporation number"
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="date"
                                                        value={publishData.section11_municipal_authority}
                                                        min={formatDateForInput(proposalData.section_11_date) || ''}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_municipal_authority: e.target.value })}
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleImageUpload('section11_municipal_authority_img', e.target.files[0])}
                                                        className="w-full p-2 border rounded text-xs"
                                                    />
                                                    {selectedDocuments['section11_municipal_authority_img'] && (
                                                        <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                                            <p className="text-xs text-green-600 truncate max-w-[70%]">
                                                                {translations[language]?.Selected}: {selectedDocuments['section11_municipal_authority_img'].name}
                                                            </p>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(selectedDocuments['section11_municipal_authority_img'])}
                                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                                            >
                                                                <Eye className="h-3 w-3" /> {translations[language].View}
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>

                                            {/* District Collector Office No and Date */}
                                            <tr>
                                                <td className="p-2 border">5</td>
                                                <td className="p-2 border">{translations[language].DistrictCollectorOffice}</td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="text"
                                                        value={publishData.section11_collector_office_no}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_collector_office_no: e.target.value })}
                                                        placeholder="Enter District Collector Office No number"
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="date"
                                                        value={publishData.section11_collector_office}
                                                        min={formatDateForInput(proposalData.section_11_date) || ''}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_collector_office: e.target.value })}
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleImageUpload('section11_collector_office_img', e.target.files[0])}
                                                        className="w-full p-2 border rounded text-xs"
                                                    />
                                                    {selectedDocuments['section11_collector_office_img'] && (
                                                        <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                                            <p className="text-xs text-green-600 truncate max-w-[70%]">
                                                                {translations[language]?.Selected}: {selectedDocuments['section11_collector_office_img'].name}
                                                            </p>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(selectedDocuments['section11_collector_office_img'])}
                                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                                            >
                                                                <Eye className="h-3 w-3" /> {translations[language].View}
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>

                                            {/* Sub-Divisional Officer No and Date */}
                                            <tr>
                                                <td className="p-2 border">6</td>
                                                <td className="p-2 border">{translations[language].SubDivisionalOfficer}</td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="text"
                                                        value={publishData.section11_sub_divisional_office_no}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_sub_divisional_office_no: e.target.value })}
                                                        placeholder="Enter Sub-Divisional Officer number"
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="date"
                                                        value={publishData.section11_sub_divisional_office}
                                                        min={formatDateForInput(proposalData.section_11_date) || ''}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_sub_divisional_office: e.target.value })}
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleImageUpload('section11_sub_divisional_office_img', e.target.files[0])}
                                                        className="w-full p-2 border rounded text-xs"
                                                    />
                                                    {selectedDocuments['section11_sub_divisional_office_img'] && (
                                                        <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                                            <p className="text-xs text-green-600 truncate max-w-[70%]">
                                                                {translations[language]?.Selected}: {selectedDocuments['section11_sub_divisional_office_img'].name}
                                                            </p>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(selectedDocuments['section11_sub_divisional_office_img'])}
                                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                                            >
                                                                <Eye className="h-3 w-3" /> {translations[language].View}
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>

                                            {/* Tehsil Office No and Date */}
                                            <tr>
                                                <td className="p-2 border">7</td>
                                                <td className="p-2 border">{translations[language].TehsilOffice}</td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="text"
                                                        value={publishData.section11_tehsil_office_no}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_tehsil_office_no: e.target.value })}
                                                        placeholder="Enter Tehsil Office number"
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="date"
                                                        value={publishData.section11_tehsil_office}
                                                        min={formatDateForInput(proposalData.section_11_date) || ''}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_tehsil_office: e.target.value })}
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleImageUpload('section11_tehsil_office_img', e.target.files[0])}
                                                        className="w-full p-2 border rounded text-xs"
                                                    />
                                                    {selectedDocuments['section11_tehsil_office_img'] && (
                                                        <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                                            <p className="text-xs text-green-600 truncate max-w-[70%]">
                                                                {translations[language]?.Selected}: {selectedDocuments['section11_tehsil_office_img'].name}
                                                            </p>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(selectedDocuments['section11_tehsil_office_img'])}
                                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                                            >
                                                                <Eye className="h-3 w-3" /> {translations[language].View}
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>

                                            {/* Government Notice Board No and Date */}
                                            <tr>
                                                <td className="p-2 border">8</td>
                                                <td className="p-2 border">{translations[language].GovernmentNoticeBoard}</td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="text"
                                                        value={publishData.section11_government_notice_board_no}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_government_notice_board_no: e.target.value })}
                                                        placeholder="Enter Government Notice Board number"
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="date"
                                                        value={publishData.section11_government_notice_board}
                                                        min={formatDateForInput(proposalData.section_11_date) || ''}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_government_notice_board: e.target.value })}
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleImageUpload('section11_government_notice_board_img', e.target.files[0])}
                                                        className="w-full p-2 border rounded text-xs"
                                                    />
                                                    {selectedDocuments['section11_government_notice_board_img'] && (
                                                        <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                                            <p className="text-xs text-green-600 truncate max-w-[70%]">
                                                                {translations[language]?.Selected}: {selectedDocuments['section11_government_notice_board_img'].name}
                                                            </p>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(selectedDocuments['section11_government_notice_board_img'])}
                                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                                            >
                                                                <Eye className="h-3 w-3" /> {translations[language].View}
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>

                                            {/* Gram Sevak Office No and Date */}
                                            <tr>
                                                <td className="p-2 border">9</td>
                                                <td className="p-2 border">{translations[language].GramSevakOffice}</td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="text"
                                                        value={publishData.section11_gram_sevak_office_no}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_gram_sevak_office_no: e.target.value })}
                                                        placeholder="Enter Gram Sevak Office No number"
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="date"
                                                        value={publishData.section11_gram_sevak_office}
                                                        min={formatDateForInput(proposalData.section_11_date) || ''}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_gram_sevak_office: e.target.value })}
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleImageUpload('section11_gram_sevak_office_img', e.target.files[0])}
                                                        className="w-full p-2 border rounded text-xs"
                                                    />
                                                    {selectedDocuments['section11_gram_sevak_office_img'] && (
                                                        <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                                            <p className="text-xs text-green-600 truncate max-w-[70%]">
                                                                {translations[language]?.Selected}: {selectedDocuments['section11_gram_sevak_office_img'].name}
                                                            </p>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(selectedDocuments['section11_gram_sevak_office_img'])}
                                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                                            >
                                                                <Eye className="h-3 w-3" /> {translations[language].View}
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>

                                            {/* Gram Panchayat Office No and Date */}
                                            {/* <tr>
                                                <td className="p-2 border">10</td>
                                                <td className="p-2 border">{translations[language].GramPanchayatOffice}</td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="text"
                                                        value={publishData.section11_gram_panchayat_office_no}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_gram_panchayat_office_no: e.target.value })}
                                                        placeholder="Enter Gram Panchayat Office number"
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="date"
                                                        value={publishData.section11_gram_panchayat_office}
                                                        min={formatDateForInput(proposalData.section_11_date) || ''}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_gram_panchayat_office: e.target.value })}
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleImageUpload('section11_gram_panchayat_office_img', e.target.files[0])}
                                                        className="w-full p-2 border rounded text-xs"
                                                    />
                                                    {selectedDocuments['section11_gram_panchayat_office_img'] && (
                                                        <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                                            <p className="text-xs text-green-600 truncate max-w-[70%]">
                                                                {translations[language]?.Selected}: {selectedDocuments['section11_gram_panchayat_office_img'].name}
                                                            </p>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(selectedDocuments['section11_gram_panchayat_office_img'])}
                                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                                            >
                                                                <Eye className="h-3 w-3" /> {translations[language].View}
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr> */}

                                            {/* PreliminaryNotificationunderRule10 No and Date */}
                                            <tr>
                                                <td className="p-2 border">10</td>
                                                <td className="p-2 border">{translations[language].PreliminaryNotificationunderRule10}</td>
                                                <td className="p-2 border text-center">-
                                                    {/* <input
                                                        type="text"
                                                        value={publishData.section11_rehabilitation_rights_notice_no}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_rehabilitation_rights_notice_no: e.target.value, propsal_publication_no: e.target.value })}
                                                        placeholder="Enter Preliminary Notification number"
                                                        className="w-full p-2 border rounded"
                                                    /> */}
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="date"
                                                        value={publishData.section11_rehabilitation_rights_notice}
                                                        min={maxDateOf10}
                                                        onChange={(e) => setPublishData({ ...publishData, section11_rehabilitation_rights_notice: e.target.value, propsal_publication_date: e.target.value })}
                                                        className="w-full p-2 border rounded"
                                                    />
                                                </td>
                                                <td className="p-2 border">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleImageUpload('section11_rehabilitation_rights_notice_img', e.target.files[0])}
                                                        className="w-full p-2 border rounded text-xs"
                                                    />
                                                    {selectedDocuments['section11_rehabilitation_rights_notice_img'] && (
                                                        <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                                            <p className="text-xs text-green-600 truncate max-w-[70%]">
                                                                {translations[language]?.Selected}: {selectedDocuments['section11_rehabilitation_rights_notice_img'].name}
                                                            </p>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(selectedDocuments['section11_rehabilitation_rights_notice_img'])}
                                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                                            >
                                                                <Eye className="h-3 w-3" /> {translations[language].View}
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                                {/* Modal Actions */}
                                <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                    <button
                                        onClick={() => setShowPublishModal(false)}
                                        className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                        disabled={publishing}
                                    >
                                        {translations[language].Cancel}
                                    </button>
                                    <button
                                        onClick={handlePublish}
                                        // disabled={publishing || !publishData.propsal_proceeding_no || !publishData.propsal_proceeding_date || !publishData.propsal_publication_no || !publishData.propsal_publication_date || (isExemptionApplicable && (!publishData.exemption_notification_number || (!uploadedImages.exemptionFile && !proposalData.exemptionFile)))}
                                        disabled={publishing || !publishData.section11_published_gazette || !publishData.section11_published_newspaper1 || !publishData.section11_published_newspaper2 || !publishData.section11_municipal_authority || !publishData.section11_collector_office || !publishData.section11_sub_divisional_office || !publishData.section11_tehsil_office || !publishData.section11_government_notice_board || !publishData.section11_gram_sevak_office || !publishData.section11_rehabilitation_rights_notice}
                                        className="px-4 py-2 bg-blue-700 text-white rounded-lg hover:bg-blue-800 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                    >
                                        {publishing ? (
                                            <>
                                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                                {translations[language].Publishing}...
                                            </>
                                        ) : (
                                            <>
                                                <Globe className="mr-2 h-4 w-4" />
                                                {translations[language]?.publish}
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Unified Document Viewer Modal */}
                {showDocumentViewer && (
                    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-3xl w-full max-w-5xl h-[95vh] shadow-2xl overflow-hidden border border-gray-200">
                            {/* Header */}
                            <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
                                <div className="flex items-center space-x-3">
                                    <h3 className="text-2xl font-bold text-gray-800 tracking-tight">Document Preview</h3>
                                </div>
                                <button
                                    onClick={closeDocumentViewer}
                                    className="w-10 h-10 rounded-full bg-gray-100 hover:bg-red-100 text-gray-500 hover:text-red-500 transition-all duration-200 flex items-center justify-center text-xl font-bold shadow-sm hover:shadow-md"
                                    aria-label="Close modal"
                                >
                                    ×
                                </button>
                            </div>

                            {/* Document Viewer Container */}
                            <div className="h-[calc(95vh)] flex flex-col">
                                <div className="flex-1 bg-gray-50 overflow-hidden shadow-inner border border-gray-200">
                                    {/* Document Content */}
                                    <div className="w-full h-full flex items-center justify-center">
                                        {isPDFToView ? (
                                            <iframe
                                                src={fileUrlToView}
                                                className="w-full h-full border-0 bg-white shadow-lg"
                                                title="PDF Preview"
                                            ></iframe>
                                        ) : (
                                            <img
                                                src={fileUrlToView}
                                                alt="File"
                                                className="w-full h-full object-contain shadow-lg"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* {showPrathmik && (
                    <HighwayPrathmikAdhisuchna
                        projectId={currentProjectId}
                        proposalId={currentProposalId}
                        onClose={() => setShowPrathmik(false)}
                    />
                )} */}

            </div>

            {showAlertModal && (
                <div className="fixed top-4 right-4 z-50">
                    <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
                        alertConfig.type === 'warning' ? 'border-yellow-500' :
                            alertConfig.type === 'info' ? 'border-blue-500' :
                                'border-green-500'
                        }`}>
                        <div className="flex items-start">
                            <div className="flex-shrink-0">
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                                    alertConfig.type === 'warning' ? 'bg-yellow-100' :
                                        alertConfig.type === 'info' ? 'bg-blue-100' :
                                            'bg-green-100'
                                    }`}>
                                    <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                                        alertConfig.type === 'warning' ? 'text-yellow-600' :
                                            alertConfig.type === 'info' ? 'text-blue-600' :
                                                'text-green-600'
                                        }`}>
                                        {alertConfig.type === 'error' ? '✕' :
                                            alertConfig.type === 'warning' ? '⚠' :
                                                alertConfig.type === 'info' ? 'ℹ' : '✓'}
                                    </span>
                                </div>
                            </div>
                            <div className="ml-3 flex-1">
                                <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                                <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
                            </div>
                            <button
                                onClick={() => setShowAlertModal(false)}
                                className="ml-4 text-gray-400 hover:text-gray-600"
                            >
                                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Simple Confirmation Modal */}
            {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
                        <div className="p-6">
                            <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                                confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                                    'bg-blue-100'
                                }`}>
                                {confirmConfig.type === 'danger' ? '⚠' :
                                    confirmConfig.type === 'warning' ? '⚠' : '?'}
                            </div>

                            <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                                {confirmConfig.title}
                            </h3>

                            <p className="text-gray-600 text-sm mb-6 text-center">
                                {confirmConfig.message}
                            </p>

                            <div className="flex gap-3">
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onCancel) confirmConfig.onCancel();
                                    }}
                                    className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                                >
                                    {translations[language]?.Cancel}
                                </button>
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                                    }}
                                    className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                                        confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                                            'bg-blue-600 hover:bg-blue-700'
                                        }`}
                                >
                                    {translations[language]?.Confirm}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showSendToTehsildarModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            {/* Header */}
                            <div className="flex justify-between items-center mb-6">
                                <h3 className="text-xl font-semibold text-gray-800">
                                    {translations[language]?.SendToTehsilar}
                                </h3>
                                <button
                                    onClick={() => setShowSendToTehsildarModal(false)}
                                    className="text-gray-400 hover:text-gray-600"
                                >
                                    <X className="h-6 w-6" />
                                </button>
                            </div>

                            {/* User Selection */}
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    {translations[language]?.selectUserTehsildar} *
                                </label>
                                <select
                                    value={selectedUserTehsildar}
                                    onChange={(e) => setSelectedUserTehsildar(e.target.value)}
                                    disabled={loadingUsersTehsildar}
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                >
                                    <option value="">
                                        {loadingUsersTehsildar ? 'Loading...' : 'वापरकर्ता निवडा (तहसीलदार)'}
                                    </option>
                                    {usersTehsildar.map((user) => (
                                        <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                            {user.full_name || user.user_name} ({user.user_role_name || 'Tehsildar'})
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Remarks */}
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    {translations[language]?.Remarks}
                                </label>
                                <textarea
                                    value={remarksTehsildar}
                                    onChange={(e) => setRemarksTehsildar(e.target.value)}
                                    rows={3}
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="Tipani / Remarks"
                                />
                            </div>

                            {/* Document Upload */}
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    {translations[language]?.UploadDocument} *
                                </label>
                                <input
                                    type="file"
                                    onChange={(e) => setSelectedDocumentTehsildar(e.target.files[0])}
                                    className="w-full p-2 border border-gray-300 rounded-lg"
                                />
                                {selectedDocumentTehsildar && (
                                    <p className="mt-1 text-sm text-green-700 font-medium truncate">
                                        {selectedDocumentTehsildar.name}
                                    </p>
                                )}
                            </div>

                            {/* Actions */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button
                                    onClick={() => setShowSendToTehsildarModal(false)}
                                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                >
                                    {translations[language]?.Cancel}
                                </button>

                                <button
                                    onClick={() => {
                                        if (isTehsildarSendButtonDisabled) return; // already sent (extra safety)
                                        handleSendToTehsildar();
                                    }}
                                    disabled={sendingToTehsildar || !selectedUserTehsildar || !selectedDocumentTehsildar || isTehsildarSendButtonDisabled}
                                    className={`flex items-center px-4 py-2 rounded-lg transition-colors ${isTehsildarSendButtonDisabled
                                        ? 'bg-red-600 text-white hover:bg-red-700'
                                        : sendingToTehsildar
                                            ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                                            : 'bg-green-600 text-white hover:bg-green-700'
                                        }`}
                                >
                                    <Send className="mr-2 h-4 w-4" />
                                    {isTehsildarSendButtonDisabled ? 'Sent to Tehsildar ✓' : 'Send to Tehsildar'}
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showExtendedModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
                        <button
                            onClick={() => setShowExtendedModal(false)}
                            className="absolute top-3 right-3 p-1 hover:bg-gray-200 rounded-full"
                        >
                            <X className="h-5 w-5 text-gray-600" />
                        </button>
                        <h2 className="text-lg font-bold mb-4">Extend Proposal</h2>

                        <div className="space-y-4">
                            {/* Date Picker */}
                            {userRole === ROLES.LAO && (
                                <div>
                                    <label className="block mb-1 font-medium">{translations[language]?.Date}</label>
                                    <input
                                        type="date"
                                        value={extendedDate}
                                        onChange={(e) => setExtendedDate(e.target.value)}
                                        className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>
                            )}
                        </div>

                        <div className="mt-6 flex justify-end space-x-2">
                            <button
                                onClick={() => setShowExtendedModal(false)}
                                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleExtendedSubmit}
                                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md"
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showSendForExtendedModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">

                        <div className="space-y-4">

                            {/* User Selection */}
                            <div>
                                <select
                                    value={selectedUser}
                                    onChange={(e) => setSelectedUser(e.target.value)}
                                    disabled={loadingUsers}
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                >
                                    <option value="">
                                        {loadingUsers ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                                    </option>
                                    {users.map((user) => (
                                        <option key={user.usr_id} value={user.usr_id}>
                                            {user.full_name} ({user.usr_role || user.user_role})
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Remarks */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    {translations[language]?.Remarks}
                                </label>
                                <textarea
                                    value={documentRemarks}
                                    onChange={(e) => setDocumentRemarks(e.target.value)}
                                    rows={3}
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="Enter remarks..."
                                />
                            </div>

                            {/* File Upload */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Upload Document *
                                </label>
                                <input
                                    type="file"
                                    onChange={(e) => setDocumentFile(e.target.files[0])}
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                />

                            </div>
                        </div>

                        <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                            <button
                                onClick={() => {
                                    setShowSendForExtendedModal(false);
                                }} className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                disabled={sendingToUser}
                            >
                                {translations[language]?.Cancel}
                            </button>
                            <button
                                onClick={handleSendToExtendsUsers}
                                disabled={sendingToUser || !selectedUser || !documentFile}
                                className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                            >
                                {sendingToUser ? (
                                    <>
                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                        {translations[language]?.sending}
                                    </>
                                ) : (
                                    <>
                                        <Send className="mr-2 h-4 w-4" />
                                        {translations[language]?.CommonSave}
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default HighwayPublishProposal;